import { useState, useRef, useEffect } from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom'

//Components
import { Grid, Chip } from "@mui/material";
import { IconButton } from "@mui/material";
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import Alert from '@mui/material/Alert';
import {
    Modal,
    ModalBody,
    ModalFooter,
    Button,
    Input,
    Form,
    Select,
    Table,
    Checkbox,
    Tooltip,
    ToggleSwitch,
    RadioButton,
    ProgressBar,
} from "@gpstrackit/react-controls";
import CustomCard from 'Components/Card';
import CustomSelect from 'Components/Select';
import FileUpload from 'Components/FileUpload';

import { getAccounts } from '../../../activities/views/main/redux/saga'
import { NotificationManager } from "Components/Notifications";
import { getBadget, getCerebrumXPackages, copyToClipboard } from 'Core/data/Helpers';


import {
    searchEntityRequest,
    devicesImportHide,
    devicesImportProcessCsv,
    devicesImportProcessCalampCsv,
    devicesImportProcessCsvQueclinkAndTopFly,
    devicesImportProcessPUICsv,
    devicesImportGetDeviceModel,
    devicesImportLoadPhoneNumbers,
    devicesImportSave,
    devicesImportGetCalampDevicesInfo,
    devicesImportProcessGeometrisCsv,
    devicesImportGetGeometrisDevicesInfo,
    devicesImportProcessCerebrumXCsv,
    devicesImportProcessCsvTelitek,
    devicesImportProcessPacificTrackCsv,
    devicesImportProcessZonarCsv,
    addIntegrationGetIntegrationsRequest,
    devicesImportProcessCsvGenX,
    devicesImportProcessCsvDigitalMatters,
    devicesImportProcessCsvLightMetrics,
    devicesImportProcessCsvM2MD,
    devicesImportProcessCsvSmartWitness,
    clearRedux
} from "Redux/actions";

import './importDevices.scss'
import { set } from "lodash";

const ImportDevices = (props) => {

    const formInput = useRef(null);
    const formManualInputCalamp = useRef(null);
    const formManualInputVidFleet = useRef(null);
    const formManualInputOthers = useRef(null);
    const formCSVInput = useRef(null);
    const tableRefCSVSymmary = useRef(null);
    const tableRefInputManual = useRef(null);
    const navigate = useNavigate()


    const { messages } = useIntl();
    const dispatch = useDispatch();

    const { loading, openModal, fileResponse, devicesPhones, importResult, calampDevices, geometrisDevices } = useSelector(state => state.importDevicesRedux)
    const deviceModelSelected = useSelector(state => state.importDevicesRedux.deviceModel)
    const integrations = useSelector(state => state.addIntegrationRedux.integrations)

    const manufacturers = useSelector(state => state.generalRedux.manufacturers);
    const loadingManufactuers = useSelector(state => state.generalRedux.manufacturersLoading);
    const deviceModels = useSelector(state => state.generalRedux.deviceModels);
    const loadingDeviceModels = useSelector(state => state.generalRedux.deviceModelsLoading);
    const simProviderAccounts = useSelector(state => state.generalRedux.simProviderAccounts);
    const timeZones = useSelector(state => state.generalRedux.timeZones);

    //Local States
    const [step, setStep] = useState(1);
    const [account, setAccount] = useState(props?.company || null);
    const [timezone, setTimezone] = useState(props?.company?.timezoneId || null)
    const [manufacturer, setManufactuer] = useState(null);
    const [deviceModel, setDeviceModel] = useState(null);
    const [simProviderAccount, setSimProviderAccount] = useState(null);
    const [reference, setReference] = useState(null);
    const [isCSV, setIsCSV] = useState(true);
    const [devices, setDevices] = useState([]);
    const [CSV, setCSV] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);
    const [error, setError] = useState(0);
    const [selectedItems, setSelectedItems] = useState([]);
    const [errors, setErrors] = useState([]);
    const [deviceSearchCriteria, setDeviceSearchCriteria] = useState("");
    const [device, setDevice] = useState({ imei: null, esn: null, iccid: null, msisdn: null })
    const [features, setFeatures] = useState({
        showPromiles: false,
        openPromilesDevices: false,
        promilesDevices: [],

        showDriverBehavior: false,
        driverBehaviorDevices: [],
        openDriverBehaviorDevices: false,

        showAnalytics: false,
        analyticsDevices: [],
        openAnalyticsDevices: false,

        showVBus: false,
        vBusDevices: [],
        openVBusDevices: false,

        showJBus: false,
        jBusDevices: [],
        openJBusDevices: false,

        ECUSpeedDevices: [],
        openECUSpeedDevices: false,

        ECUOdometerDevices: [],
        openECUOdometerDevices: false,
        //--------------

        assetDevices: [],
        openAssetDevices: false,

        fleetDevices: [],
        openFleetDevices: false,

        openApuDevices: false,
        openHybridDevices: false,
        openShowDevices: false,
        openPromilesOdometerCalculatedDevices: false,
        openUseEcuOdometerDevices: false,
        openUseEcuEngineHoursDevices: false,
        openUseEcuSpeedDevices: false,
        openUseEcuVinDevices: false,
        openLinkedModeDevices: false,

        showCariq: false,
        cariqDevices: [],
        openCariqDevices: false,

        showCarb: false,
        carbDevices: [],
        openCarbDevices: false,

    });
    //features to load
    const [featuresOptions, setFeaturesOptions] = useState([

        {
            key: "showPromiles",
            keyOpen: "openPromilesDevices",
            keyDevices: "promilesDevices",
            field: "promiles",
            label: "devices_import_promiles"
        },
        {
            key: "showPromilesOdometerCalculated",
            keyOpen: "openPromilesOdometerCalculatedDevices",
            keyDevices: "promilesOdometerCalculatedDevices",
            field: "promilesOdometerCalculated",
            label: "devices_import_promiles_odometer_calculated"
        },
        {
            key: "showDriverBehavior",
            keyOpen: "openDriverBehaviorDevices",
            keyDevices: "driverBehaviorDevices",
            field: "driverBehavior",
            label: "devices_import_driver_behavior"
        },
        {
            key: "showVBus",
            keyOpen: "OpenVBusDevices",
            keyDevices: "vBusDevices",
            field: "vbus",
            label: "devices_import_vbus"
        },
        {
            key: "showJBus",
            keyOpen: "openJBusDevices",
            keyDevices: "jBusDevices",
            field: "jbus",
            label: "devices_import_jbus"
        },
        {
            key: "showComData",
            keyOpen: "openComDataDevices",
            keyDevices: "comDataDevices",
            field: "comData",
            label: "devices_import_com_data"
        },
        {
            key: "showPressurePro",
            keyOpen: "openPressureProDevices",
            keyDevices: "pressureProDevices",
            field: "pressurePro",
            label: "devices_import_pressure_pro"
        },
        {
            key: "showBattery",
            keyOpen: "openBateryDevices",
            keyDevices: "batteryDevices",
            field: "battery",
            label: "devices_import_battery"
        },
        {
            key: "showAnalytics",
            keyOpen: "openAnalyticsDevices",
            keyDevices: "analyticsDevices",
            field: "analytics",
            label: "devices_import_analytics"
        },
        {
            key: "showUseEcuEngineHours",
            keyOpen: "openUseEcuEngineHoursDevices",
            keyDevices: "useEcuEngineHoursDevices",
            field: "useEcuEngineHours",
            label: "devices_import_use_ecu_engine_hours"
        },
        {
            key: "showUseEcuOdometer",
            keyOpen: "openUseEcuOdometerDevices",
            keyDevices: "useEcuOdometerDevices",
            field: "useEcuOdometer",
            label: "devices_import_use_ecu_odometer"
        },
        {
            key: "showUseEcuSpeed",
            keyOpen: "openUseEcuSpeedDevices",
            keyDevices: "useEcuSpeedDevices",
            field: "useEcuSpeed",
            label: "devices_import_use_ecu_speed"
        },
        {
            key: "showUseEcuVin",
            keyOpen: "openUseEcuVinDevices",
            keyDevices: "useEcuVinDevices",
            field: "useEcuVin",
            label: "devices_import_use_ecu_vin"
        },
        {
            key: "showApu",
            keyOpen: "OpenApuDevices",
            keyDevices: "apuDevices",
            field: "apu",
            label: "devices_import_apu"
        },
        {
            key: "showHybrid",
            keyOpen: "OpenHybridDevices",
            keyDevices: "hybridDevices",
            field: "hybrid",
            label: "devices_import_hybrid"
        },
        {
            key: "show",
            keyOpen: "OpenShowDevices",
            keyDevices: "showDevices",
            field: "show",
            label: "devices_import_show"
        },
        {
            key: "showLinkedMode",
            keyOpen: "OpenLinkedModeDevices",
            keyDevices: "linkedModeDevices",
            field: "linkedMode",
            label: "devices_import_camera_paired_mode"
        },
        {
            key: "showCariq",
            keyOpen: "openCariqDevices",
            keyDevices: "cariqDevices",
            field: "cariq",
            label: "devices_import_cariq"
        },
        {
            key: "showCarb",
            keyOpen: "openCarbDevices",
            keyDevices: "carbDevices",
            field: "carb",
            label: "devices_import_carb"
        }

    ]);
    const [geometrisModelsAvailables, setGeometrisModelsAvailables] = useState(["88", "87", "95", "96"]);
    const [isIntegrationEnabled, setIsIntegrationEnabled] = useState(false)
    const [packageName, setPackageName] = useState(null)
    const [selectedTags, setSelectedTags] = useState([]);
    const [companyIntegration, setCompanyIntegration] = useState(null)

    const closeModal = () => {
        setStep(1);
        setAccount(null);
        setManufactuer(null);
        setReference(null);
        setIsIntegrationEnabled(false)
        setPackageName(null)
        setSelectedTags([])
        dispatch(clearRedux("IMPORT_DEVICES"));
        dispatch(clearRedux("ADD_INTEGRATION"));
        dispatch(devicesImportHide());
    }

    const getAccountsForSelect = (input, callback) => {
        if (!input) {
            callback([])
            return
        }
        getAccounts(input).then((response) => {
            if (response.result) {
                const { items } = response?.result
                callback(items)
            }
        })
    }

    //step 1
    const renderInputSelection = () => {
        return (
            <Grid className="step-container" style={{ height: 450 }}>
                <Form
                    ref={formInput}
                    onValidSubmit={() => {
                        setStep(2);
                    }}
                >
                    <Grid container>
                        <Grid item xs={12} >
                            <CustomSelect
                                async
                                value={account}
                                onChange={(item) => {
                                    setAccount(item)
                                    setTimezone(item?.timezoneId || null)

                                    if (manufacturer?.name?.toUpperCase() === "CEREBRUMX") {
                                        let cerebrum = integrations.find(x => x.code.toUpperCase() === "CEREBRUMX")
                                        let companyIntegration = item?.integrations?.find(x => x.integrationId === cerebrum.id)
                                        if (companyIntegration) {
                                            let parameters = JSON.parse(companyIntegration.parameters)
                                            if (parameters?.fleetStatus === "ACTIVE")
                                                setIsIntegrationEnabled(true);
                                            else
                                                setIsIntegrationEnabled(false);
                                        }
                                        setCompanyIntegration(null)
                                    } else if (manufacturer?.name?.toUpperCase() === "ZONAR") {
                                        let zonar = integrations.find(x => x.code.toUpperCase() === "ZONAR")
                                        let companyIntegration = item?.integrations?.find(x => x.integrationId === zonar.id)
                                        if (companyIntegration) {
                                            setCompanyIntegration(companyIntegration)
                                            setIsIntegrationEnabled(true);
                                        } else {
                                            setCompanyIntegration(null)
                                            setIsIntegrationEnabled(false);
                                        }
                                    } else {
                                        setCompanyIntegration(null)
                                    }

                                }}
                                label={messages['devices_import_account']}
                                placeholder={messages["devices_import_account"]}
                                loadOptions={getAccountsForSelect}
                                required
                                getOptionLabel={e => e.name}
                                getOptionValue={e => e.id}

                            />
                        </Grid>
                        <Grid item xs={12} style={{ marginTop: 10 }} >
                            <Input
                                label={`${messages["devices_import_ref_number"]}`}
                                placeholder={messages["devices_import_ref_number"]}
                                requiredMessage={messages['common_field_required']}
                                value={reference || ""}
                                onChange={(value) => {
                                    setReference(value)
                                }}
                                maxLength={50}
                                minLength={1}
                                required
                            />
                        </Grid>
                        <Grid item xs={12} style={{ marginTop: 10 }} >
                            <Select
                                id="timezones"
                                label={messages['feature_tab_timezone']}
                                placeholder={messages['feature_tab_timezone']}
                                options={timeZones || []}
                                value={timezone ? timeZones.find(x => x.id === timezone) : null}
                                textField="name"
                                valueField="id"
                                onChange={(timezone) => {
                                    setTimezone(timezone?.id || null)
                                }}
                                required
                                requiredMessage={messages['required_field']}
                            />
                        </Grid>
                        <Grid item xs={6} style={{ marginTop: 10 }} >
                            <RadioButton
                                onChange={(value) => {
                                    setIsCSV(true);
                                }}
                                value={isCSV}
                                label={messages['devices_import_csv_import']}
                                position="end"
                            />
                        </Grid>
                        <Grid item xs={6} style={{ marginTop: 10 }} >
                            <RadioButton
                                onChange={(value) => {
                                    setIsCSV(false);
                                }}
                                value={!isCSV}
                                label={messages['devices_import_manual_import']}
                                position="end"
                            />
                        </Grid>
                        <Grid item xs={12} style={{ marginTop: 10 }} >
                            <Select
                                id="import-manufacturer"
                                name="Manufacturer"
                                label={messages["devices_import_manufacturer"]}
                                placeholder={messages["devices_import_manufacturer"]}
                                className={"react-select-container-custom"}
                                value={manufacturer}
                                onChange={(value) => {
                                    setManufactuer(value);
                                    if (value.name.toUpperCase() === "CEREBRUMX") {
                                        let cerebrum = integrations.find(x => x.code.toUpperCase() === "CEREBRUMX")
                                        let companyIntegration = account?.integrations?.find(x => x.integrationId === cerebrum.id)
                                        if (companyIntegration) {
                                            let parameters = JSON.parse(companyIntegration.parameters)
                                            if (parameters?.fleetStatus === "ACTIVE")
                                                setIsIntegrationEnabled(true);
                                        }
                                        setCompanyIntegration(null)
                                    } else if (value.name.toUpperCase() === "ZONAR") {
                                        let zonar = integrations.find(x => x.code.toUpperCase() === "ZONAR")
                                        let companyIntegration = account?.integrations?.find(x => x.integrationId === zonar.id)
                                        if (companyIntegration) {
                                            setCompanyIntegration(companyIntegration)
                                            setIsIntegrationEnabled(true);
                                        } else {
                                            setCompanyIntegration(null)
                                            setIsIntegrationEnabled(false);
                                        }
                                    } else {
                                        setCompanyIntegration(null)
                                    }
                                    if (value.name.toUpperCase() === "CEREBRUMX") {
                                        let devModels = deviceModels.filter(x => x.manufacturerId === value.id) || []
                                        if (devModels.length > 0) {
                                            setDeviceModel(devModels[0])
                                            dispatch(devicesImportGetDeviceModel(devModels[0].id));
                                        }
                                    } else
                                        setDeviceModel(null)

                                    // special case for M2MD to set sim provider account to AT&T Standard 
                                    if (value.name.toUpperCase() === "M2MD") {
                                        let simProv = simProviderAccounts.find(x => x.name === "Standard" && x.simProvider.name === "AT&T")
                                        if (simProv)
                                            setSimProviderAccount(simProv)
                                    } else
                                        setSimProviderAccount(null)
                                }}
                                loading={loadingManufactuers}
                                options={
                                    manufacturers && isCSV ?
                                        (manufacturers.filter(x => x.name.toUpperCase() === "CALAMP" ||
                                            x.name.toUpperCase() === "GEOMETRIS" ||
                                            x.name.toUpperCase() === "POSITIONING UNIVERSAL" ||
                                            x.name.toUpperCase() === "VIDFLEET" ||
                                            x.name.toUpperCase() === "QUECLINK" ||
                                            x.name.toUpperCase() === "TOPFLY" ||
                                            x.name.toUpperCase() === "CEREBRUMX" ||
                                            x.name.toUpperCase() === "TELITEK" ||
                                            x.name.toUpperCase() === "PACIFIC TRACK" ||
                                            x.name.toUpperCase() === "ZONAR" ||
                                            x.name.toUpperCase() === "GENX" ||
                                            x.name.toUpperCase() === "DIGITAL MATTER" ||
                                            x.name.toUpperCase() === "LIGHTMETRICS" ||
                                            x.name.toUpperCase() === "M2MD" ||
                                            x.name.toUpperCase() === "SMARTWITNESS"
                                        )
                                        ) : manufacturers || []
                                }
                                errorMessage={messages['common_field_required']}
                                textField="name"
                                valueField="id"
                                getOptionLabel={e => e.name}
                                getOptionValue={e => e.id}
                                required
                            />
                        </Grid>
                        {
                            (manufacturer?.name?.toUpperCase() === "CEREBRUMX" || manufacturer?.name?.toUpperCase() === "ZONAR") && !isIntegrationEnabled &&
                            <Grid item xs={12} style={{ marginTop: 10 }} >
                                <Alert severity="error">
                                    {manufacturer?.name?.toUpperCase() === "CEREBRUMX" ? messages["devices_import_not_cerebrum"] : messages["devices_import_not_zonar"]}
                                </Alert>
                            </Grid>
                        }
                        {
                            companyIntegration && manufacturer?.name?.toUpperCase() === "ZONAR" &&
                            <Grid item xs={12} style={{ marginTop: 10 }} >
                                <Alert severity="info">
                                    {`${messages["devices_import_zonar_account_id"]} - ${companyIntegration?.parameters.length > 0 ? JSON.parse(companyIntegration?.parameters)?.id : ''} `}
                                </Alert>
                            </Grid>
                        }
                    </Grid>
                </Form>
            </Grid>
        )
    }

    //step 2 isCSV
    const renderInputFormCSV = () => {
        return (
            <Grid className="step-container">
                <Form
                    ref={formCSVInput}
                    onValidSubmit={() => {
                        if (manufacturer.name.toUpperCase() === "CALAMP") {
                            dispatch(devicesImportProcessCalampCsv(CSV));
                        } else if (manufacturer.name.toUpperCase() === "GEOMETRIS") {
                            dispatch(devicesImportProcessGeometrisCsv(CSV));
                        } else if (manufacturer.name.toUpperCase() === "QUECLINK" || manufacturer.name.toUpperCase() === "TOPFLY") {
                            dispatch(devicesImportProcessCsvQueclinkAndTopFly(CSV));
                        } else if (manufacturer.name.toUpperCase() === "VIDFLEET") {
                            let newDevices = []
                            let csvDevices = CSV.split('\n');
                            csvDevices?.shift();

                            let currentSimProvideraccount = simProviderAccount

                            csvDevices = [...new Set(csvDevices)];

                            csvDevices.map((device) => {
                                if (device) {
                                    let newDev = device.replace(/(\r\n|\n|\r)/gm, '').trim().split(",")
                                    if (newDev.length > 1)
                                        newDevices.push({
                                            esn: newDev[0],
                                            label: newDev[0],
                                            iccid: newDev[1] || "",
                                            msisdn: newDev[2] || "",
                                            simProviderAccount: currentSimProvideraccount,
                                            Error: 0
                                        })
                                    else
                                        newDevices.push({
                                            esn: newDev[0],
                                            label: newDev[0],
                                            simProviderAccount: currentSimProvideraccount,
                                            Error: 0
                                        })
                                }
                            })
                            setDevices([...newDevices]);
                        } else if (manufacturer?.name?.toUpperCase() === "CEREBRUMX") {
                            dispatch(devicesImportProcessCerebrumXCsv(CSV));
                        } else if (manufacturer.name.toUpperCase() === "TELITEK") {
                            dispatch(devicesImportProcessCsvTelitek(CSV));
                        } else if (manufacturer.name.toUpperCase() === "PACIFIC TRACK") {
                            dispatch(devicesImportProcessPacificTrackCsv(CSV));
                        } else if (manufacturer.name.toUpperCase() === "ZONAR") {
                            dispatch(devicesImportProcessZonarCsv(CSV));
                        } else if (manufacturer.name.toUpperCase() === "GENX") {
                            dispatch(devicesImportProcessCsvGenX(CSV));
                        } else if (manufacturer.name.toUpperCase() === "DIGITAL MATTER") {
                            dispatch(devicesImportProcessCsvDigitalMatters(CSV));
                        } else if (manufacturer.name.toUpperCase() === "LIGHTMETRICS") {
                            dispatch(devicesImportProcessCsvLightMetrics(CSV));
                        } else if (manufacturer.name.toUpperCase() === "M2MD") {
                            dispatch(devicesImportProcessCsvM2MD(CSV));
                        } else if (manufacturer.name.toUpperCase() === "SMARTWITNESS") {
                            dispatch(devicesImportProcessCsvSmartWitness(CSV));
                        } else {
                            dispatch(devicesImportProcessPUICsv(CSV));
                        }

                        if (manufacturer.name.toUpperCase() === "VIDFLEET") {
                            setStep(3);
                        } else {
                            setStep(3);
                            setDevices([]);
                        }
                    }}
                >
                    {
                        (
                            manufacturer.name.toUpperCase() === "POSITIONING UNIVERSAL" ||
                            manufacturer.name.toUpperCase() === "QUECLINK" ||
                            manufacturer.name.toUpperCase() === "TOPFLY" ||
                            manufacturer.name.toUpperCase() === "PACIFIC TRACK" ||
                            manufacturer.name.toUpperCase() === "TELITEK" ||
                            manufacturer.name.toUpperCase() === "GENX" ||
                            manufacturer.name.toUpperCase() === "DIGITAL MATTER" ||
                            manufacturer.name.toUpperCase() === "M2MD" ||
                            manufacturer.name.toUpperCase() === "SMARTWITNESS"
                        ) &&
                        <Grid>

                            <Grid xs={12}>
                                <Grid>
                                    <Select
                                        id="import-device-model"
                                        label={messages["devices_import_device_type"]}
                                        placeholder={messages["devices_import_device_type"]}
                                        value={deviceModel}
                                        onChange={(value) => {
                                            setDeviceModel(value);
                                            dispatch(devicesImportGetDeviceModel(value.id));
                                        }}
                                        loading={loadingDeviceModels}
                                        options={deviceModels && deviceModels.filter(x => x.manufacturerId === manufacturer.id) || []}
                                        errorMessage={messages['common_field_required']}
                                        textField="name"
                                        valueField="id"
                                        required
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    }
                    {
                        manufacturer.name.toUpperCase() !== "CEREBRUMX" &&
                        manufacturer.name.toUpperCase() !== "ZONAR" &&
                        manufacturer.name.toUpperCase() !== "M2MD" &&
                        <Grid>
                            <Grid xs={12} style={{ marginTop: 10 }}>
                                <Select
                                    id="import-simprovider-account"
                                    label={messages["devices_import_sim_provider_account"]}
                                    placeholder={messages["devices_import_sim_provider_account"]}
                                    value={simProviderAccount}
                                    onChange={(value) => {
                                        setSimProviderAccount(value)
                                    }}
                                    options={simProviderAccounts}
                                    requiredMessage={messages['common_field_required']}
                                    getOptionLabel={e => `${e.name}${e.simProvider ? ` - ${e.simProvider.name}` : ''}`}
                                    getOptionValue={e => e.id}
                                    textField="name"
                                    valueField="id"
                                    required
                                />
                            </Grid>
                        </Grid>
                    }
                    <Grid xs={12} style={{ marginTop: 10 }}>
                        <Grid item>
                            <FileUpload
                                type="file"
                                name="CsvFile"
                                id="CsvFile"
                                accept=".csv"
                                label={messages["devices_import_csv_file"]}
                                errorMessage={messages['common_field_required']}
                                onChange={(e) => {
                                    const { files } = e.target;
                                    let fileReader = new FileReader();
                                    fileReader.onloadend = (e) => {
                                        let content = fileReader.result;

                                        setCSV(content)
                                        setErrorMessage(null)
                                    };
                                    fileReader.readAsText(files[0]);
                                }}
                                validate={{
                                    required: { value: true, errorMessage: messages['common_field_required'] }
                                }}
                            />
                        </Grid>
                        <Grid item>
                            {
                                manufacturer.name.toUpperCase() === "CALAMP" &&
                                <div color="muted">
                                    {messages["devices_import_csv_file_sample_csv"]}
                                    <br></br>
                                    <span
                                        className="ml-2 btn-link"
                                        onClick={() => {
                                            // Example data given in question text
                                            var data = [["ESN"]];

                                            // Building the CSV from the Data two-dimensional array
                                            // Each column is separated by ";" and new line "\n" for next Grid
                                            var csvContent = '';
                                            data.forEach(function (infoArray, index) {
                                                let dataString = infoArray.join(',');
                                                csvContent += index < data.length ? dataString + '\n' : dataString;
                                            });

                                            var a = document.createElement('a');
                                            let mimeType = 'text/csv;encoding:utf-8'

                                            if (navigator.msSaveBlob) { // IE10
                                                navigator.msSaveBlob(new Blob([content], {
                                                    type: mimeType
                                                }), 'devices.csv');
                                            } else if (URL && 'download' in a) { //html5 A[download]
                                                a.href = URL.createObjectURL(new Blob([csvContent], {
                                                    type: mimeType
                                                }));
                                                a.setAttribute('download', 'devices_calamp_1.csv');
                                                document.body.appendChild(a);
                                                a.click();
                                                document.body.removeChild(a);
                                            } else {
                                                location.href = 'data:application/octet-stream,' + encodeURIComponent(content); // only this mime type is supported
                                            }
                                        }}
                                    >
                                        {messages["devices_import_csv_file_download_sample"]} : ESN
                                    </span>
                                    <br></br>
                                    <span
                                        className="ml-2 btn-link"
                                        onClick={() => {
                                            // Example data given in question text
                                            var data = [["ESN", "ICCID"]];

                                            // Building the CSV from the Data two-dimensional array
                                            // Each column is separated by ";" and new line "\n" for next Grid
                                            var csvContent = '';
                                            data.forEach(function (infoArray, index) {
                                                let dataString = infoArray.join(',');
                                                csvContent += index < data.length ? dataString + '\n' : dataString;
                                            });

                                            var a = document.createElement('a');
                                            let mimeType = 'text/csv;encoding:utf-8'

                                            if (navigator.msSaveBlob) { // IE10
                                                navigator.msSaveBlob(new Blob([content], {
                                                    type: mimeType
                                                }), 'devices.csv');
                                            } else if (URL && 'download' in a) { //html5 A[download]
                                                a.href = URL.createObjectURL(new Blob([csvContent], {
                                                    type: mimeType
                                                }));
                                                a.setAttribute('download', 'devices_calamp_2.csv');
                                                document.body.appendChild(a);
                                                a.click();
                                                document.body.removeChild(a);
                                            } else {
                                                location.href = 'data:application/octet-stream,' + encodeURIComponent(content); // only this mime type is supported
                                            }
                                        }}
                                    >
                                        {messages["devices_import_csv_file_download_sample"]} : ESN, ICCID
                                    </span>
                                    <br></br>
                                    <span
                                        className="ml-2 btn-link"
                                        onClick={() => {
                                            // Example data given in question text
                                            var data = [["ESN", "ICCID", "MSISDN"]];

                                            // Building the CSV from the Data two-dimensional array
                                            // Each column is separated by ";" and new line "\n" for next Grid
                                            var csvContent = '';
                                            data.forEach(function (infoArray, index) {
                                                let dataString = infoArray.join(',');
                                                csvContent += index < data.length ? dataString + '\n' : dataString;
                                            });

                                            var a = document.createElement('a');
                                            let mimeType = 'text/csv;encoding:utf-8'

                                            if (navigator.msSaveBlob) { // IE10
                                                navigator.msSaveBlob(new Blob([content], {
                                                    type: mimeType
                                                }), 'devices.csv');
                                            } else if (URL && 'download' in a) { //html5 A[download]
                                                a.href = URL.createObjectURL(new Blob([csvContent], {
                                                    type: mimeType
                                                }));
                                                a.setAttribute('download', 'devices_calamp_2.csv');
                                                document.body.appendChild(a);
                                                a.click();
                                                document.body.removeChild(a);
                                            } else {
                                                location.href = 'data:application/octet-stream,' + encodeURIComponent(content); // only this mime type is supported
                                            }
                                        }}
                                    >
                                        {messages["devices_import_csv_file_download_sample"]} : ESN, ICCID, MSISDN
                                    </span>
                                    <br></br>
                                    <span
                                        className="ml-2 btn-link"
                                        onClick={() => {
                                            // Example data given in question text
                                            var data = [["ESN", "ICCID", "MSISDN", "LABEL"]];

                                            // Building the CSV from the Data two-dimensional array
                                            // Each column is separated by ";" and new line "\n" for next Grid
                                            var csvContent = '';
                                            data.forEach(function (infoArray, index) {
                                                let dataString = infoArray.join(',');
                                                csvContent += index < data.length ? dataString + '\n' : dataString;
                                            });

                                            var a = document.createElement('a');
                                            let mimeType = 'text/csv;encoding:utf-8'

                                            if (navigator.msSaveBlob) { // IE10
                                                navigator.msSaveBlob(new Blob([content], {
                                                    type: mimeType
                                                }), 'devices.csv');
                                            } else if (URL && 'download' in a) { //html5 A[download]
                                                a.href = URL.createObjectURL(new Blob([csvContent], {
                                                    type: mimeType
                                                }));
                                                a.setAttribute('download', 'devices_calamp_2.csv');
                                                document.body.appendChild(a);
                                                a.click();
                                                document.body.removeChild(a);
                                            } else {
                                                location.href = 'data:application/octet-stream,' + encodeURIComponent(content); // only this mime type is supported
                                            }
                                        }}
                                    >
                                        {messages["devices_import_csv_file_download_sample"]} : ESN, ICCID, MSISDN, LABEL
                                    </span>
                                </div>
                            }
                            {
                                manufacturer.name.toUpperCase() === "GEOMETRIS" &&
                                <div color="muted">
                                    {messages["devices_import_csv_file_instructions"]}
                                    <br></br>
                                    <span
                                        className="ml-2 btn-link"
                                        onClick={() => {
                                            // Example data given in question text
                                            var data = [
                                                ['SERIAL']
                                            ];

                                            // Building the CSV from the Data two-dimensional array
                                            // Each column is separated by ";" and new line "\n" for next Grid
                                            var csvContent = '';
                                            data.forEach(function (infoArray, index) {
                                                let dataString = infoArray.join(',');
                                                csvContent += index < data.length ? dataString + '\n' : dataString;
                                            });

                                            var a = document.createElement('a');
                                            let mimeType = 'text/csv;encoding:utf-8'

                                            if (navigator.msSaveBlob) { // IE10
                                                navigator.msSaveBlob(new Blob([content], {
                                                    type: mimeType
                                                }), 'devices.csv');
                                            } else if (URL && 'download' in a) { //html5 A[download]
                                                a.href = URL.createObjectURL(new Blob([csvContent], {
                                                    type: mimeType
                                                }));
                                                a.setAttribute('download', 'devices.csv');
                                                document.body.appendChild(a);
                                                a.click();
                                                document.body.removeChild(a);
                                            } else {
                                                location.href = 'data:application/octet-stream,' + encodeURIComponent(content); // only this mime type is supported
                                            }
                                        }}
                                    >
                                        {messages["devices_import_csv_file_download_sample"]}
                                    </span>
                                </div>
                            }
                            {
                                (manufacturer.name.toUpperCase() === "QUECLINK" || manufacturer.name.toUpperCase() === "TOPFLY") &&
                                <div color="muted">
                                    {messages["devices_import_csv_file_instructions_queclink"]}
                                    <br></br>
                                    <span
                                        className="ml-2 btn-link"
                                        onClick={() => {
                                            // Example data given in question text
                                            let name = 'devicesQueclink.csv'
                                            if (manufacturer.name.toUpperCase() === "TOPFLY") {
                                                name = 'devicesTopFly.csv'
                                            }
                                            var data = [
                                                ['IMEI', 'ICCID', 'MSISDN']
                                            ];

                                            // Building the CSV from the Data two-dimensional array
                                            // Each column is separated by ";" and new line "\n" for next Grid
                                            var csvContent = '';
                                            data.forEach(function (infoArray, index) {
                                                let dataString = infoArray.join(',');
                                                csvContent += index < data.length ? dataString + '\n' : dataString;
                                            });

                                            var a = document.createElement('a');
                                            let mimeType = 'text/csv;encoding:utf-8'

                                            if (navigator.msSaveBlob) { // IE10
                                                navigator.msSaveBlob(new Blob([content], {
                                                    type: mimeType
                                                }), name);
                                            } else if (URL && 'download' in a) { //html5 A[download]
                                                a.href = URL.createObjectURL(new Blob([csvContent], {
                                                    type: mimeType
                                                }));
                                                a.setAttribute('download', name);
                                                document.body.appendChild(a);
                                                a.click();
                                                document.body.removeChild(a);
                                            } else {
                                                location.href = 'data:application/octet-stream,' + encodeURIComponent(content); // only this mime type is supported
                                            }
                                        }}
                                    >
                                        {messages["devices_import_csv_file_download_sample"]}
                                    </span>
                                </div>
                            }
                            {
                                manufacturer.name.toUpperCase() === "VIDFLEET" &&
                                <div color="muted">
                                    {messages["devices_import_csv_file_instructions_serial"]}
                                    <br></br>
                                    <span
                                        className="ml-2 btn-link"
                                        onClick={() => {
                                            // Example data given in question text
                                            var data = [
                                                ['SERIAL']
                                            ];

                                            // Building the CSV from the Data two-dimensional array
                                            // Each column is separated by ";" and new line "\n" for next Grid
                                            var csvContent = '';
                                            data.forEach(function (infoArray, index) {
                                                let dataString = infoArray.join(',');
                                                csvContent += index < data.length ? dataString + '\n' : dataString;
                                            });

                                            var a = document.createElement('a');
                                            let mimeType = 'text/csv;encoding:utf-8'

                                            if (navigator.msSaveBlob) { // IE10
                                                navigator.msSaveBlob(new Blob([content], {
                                                    type: mimeType
                                                }), 'devices.csv');
                                            } else if (URL && 'download' in a) { //html5 A[download]
                                                a.href = URL.createObjectURL(new Blob([csvContent], {
                                                    type: mimeType
                                                }));
                                                a.setAttribute('download', 'devices.csv');
                                                document.body.appendChild(a);
                                                a.click();
                                                document.body.removeChild(a);
                                            } else {
                                                location.href = 'data:application/octet-stream,' + encodeURIComponent(content); // only this mime type is supported
                                            }
                                        }}
                                    >
                                        {messages["devices_import_csv_file_download_sample"]}  : SERIAL
                                    </span>
                                    <br></br>
                                    <span
                                        className="ml-2 btn-link"
                                        onClick={() => {
                                            // Example data given in question text
                                            var data = [
                                                ['SERIAL', 'ICCID', 'MSISDN']
                                            ];

                                            // Building the CSV from the Data two-dimensional array
                                            // Each column is separated by ";" and new line "\n" for next Grid
                                            var csvContent = '';
                                            data.forEach(function (infoArray, index) {
                                                let dataString = infoArray.join(',');
                                                csvContent += index < data.length ? dataString + '\n' : dataString;
                                            });

                                            var a = document.createElement('a');
                                            let mimeType = 'text/csv;encoding:utf-8'

                                            if (navigator.msSaveBlob) { // IE10
                                                navigator.msSaveBlob(new Blob([content], {
                                                    type: mimeType
                                                }), 'devices.csv');
                                            } else if (URL && 'download' in a) { //html5 A[download]
                                                a.href = URL.createObjectURL(new Blob([csvContent], {
                                                    type: mimeType
                                                }));
                                                a.setAttribute('download', 'devices.csv');
                                                document.body.appendChild(a);
                                                a.click();
                                                document.body.removeChild(a);
                                            } else {
                                                location.href = 'data:application/octet-stream,' + encodeURIComponent(content); // only this mime type is supported
                                            }
                                        }}
                                    >
                                        {messages["devices_import_csv_file_download_sample"]} : SERIAL, ICCID, MSISDN
                                    </span>
                                </div>
                            }
                            {
                                manufacturer.name.toUpperCase() === "POSITIONING UNIVERSAL" &&
                                <div color="muted">
                                    {messages["devices_import_csv_file_instructions_pui"]}
                                    <span
                                        className="ml-2 btn-link"
                                        onClick={() => {
                                            // Example data given in question text
                                            var data = [
                                                ['IMEI', 'ICCID', 'MSISDN']
                                            ];

                                            // Building the CSV from the Data two-dimensional array
                                            // Each column is separated by ";" and new line "\n" for next Grid
                                            var csvContent = '';
                                            data.forEach(function (infoArray, index) {
                                                let dataString = infoArray.join(',');
                                                csvContent += index < data.length ? dataString + '\n' : dataString;
                                            });

                                            var a = document.createElement('a');
                                            let mimeType = 'text/csv;encoding:utf-8'

                                            if (navigator.msSaveBlob) { // IE10
                                                navigator.msSaveBlob(new Blob([content], {
                                                    type: mimeType
                                                }), 'devicesPUI.csv');
                                            } else if (URL && 'download' in a) { //html5 A[download]
                                                a.href = URL.createObjectURL(new Blob([csvContent], {
                                                    type: mimeType
                                                }));
                                                a.setAttribute('download', 'devicesPUI.csv');
                                                document.body.appendChild(a);
                                                a.click();
                                                document.body.removeChild(a);
                                            } else {
                                                location.href = 'data:application/octet-stream,' + encodeURIComponent(content); // only this mime type is supported
                                            }
                                        }}
                                    >
                                        {messages["devices_import_csv_file_download_sample"]}
                                    </span>
                                </div>
                            }
                            {
                                manufacturer.name.toUpperCase() === "CEREBRUMX" &&
                                <div color="muted">
                                    {messages["devices_import_csv_file_instructions_cerebrumx"]}
                                    <span
                                        className="ml-2 btn-link"
                                        onClick={() => {
                                            // Example data given in question text
                                            var data = [
                                                ['VIN#', 'PACKAGENAME']
                                            ];

                                            // Building the CSV from the Data two-dimensional array
                                            // Each column is separated by ";" and new line "\n" for next Grid
                                            var csvContent = '';
                                            data.forEach(function (infoArray, index) {
                                                let dataString = infoArray.join(',');
                                                csvContent += index < data.length ? dataString + '\n' : dataString;
                                            });

                                            var a = document.createElement('a');
                                            let mimeType = 'text/csv;encoding:utf-8'

                                            if (navigator.msSaveBlob) { // IE10
                                                navigator.msSaveBlob(new Blob([content], {
                                                    type: mimeType
                                                }), 'devicesCerebrumX.csv');
                                            } else if (URL && 'download' in a) { //html5 A[download]
                                                a.href = URL.createObjectURL(new Blob([csvContent], {
                                                    type: mimeType
                                                }));
                                                a.setAttribute('download', 'devicesCerebrumX.csv');
                                                document.body.appendChild(a);
                                                a.click();
                                                document.body.removeChild(a);
                                            } else {
                                                location.href = 'data:application/octet-stream,' + encodeURIComponent(content); // only this mime type is supported
                                            }
                                        }}
                                    >
                                        {messages["devices_import_csv_file_download_sample"]}
                                    </span>
                                </div>
                            }
                            {
                                manufacturer.name.toUpperCase() === "TELITEK" &&
                                <div color="muted">
                                    {messages["devices_import_csv_file_instructions_telitek"]}
                                    <span
                                        className="ml-2 btn-link"
                                        onClick={() => {
                                            // Example data given in question text
                                            var data = [
                                                ['SERIAL', 'IMEI', 'ICCID', 'MSISDN']
                                            ];

                                            // Building the CSV from the Data two-dimensional array
                                            // Each column is separated by ";" and new line "\n" for next Grid
                                            var csvContent = '';
                                            data.forEach(function (infoArray, index) {
                                                let dataString = infoArray.join(',');
                                                csvContent += index < data.length ? dataString + '\n' : dataString;
                                            });

                                            var a = document.createElement('a');
                                            let mimeType = 'text/csv;encoding:utf-8'

                                            if (navigator.msSaveBlob) { // IE10
                                                navigator.msSaveBlob(new Blob([content], {
                                                    type: mimeType
                                                }), 'devicesPUI.csv');
                                            } else if (URL && 'download' in a) { //html5 A[download]
                                                a.href = URL.createObjectURL(new Blob([csvContent], {
                                                    type: mimeType
                                                }));
                                                a.setAttribute('download', 'devicesTelitek.csv');
                                                document.body.appendChild(a);
                                                a.click();
                                                document.body.removeChild(a);
                                            } else {
                                                location.href = 'data:application/octet-stream,' + encodeURIComponent(content); // only this mime type is supported
                                            }
                                        }}
                                    >
                                        {messages["devices_import_csv_file_download_sample"]}
                                    </span>
                                </div>
                            }
                            {
                                manufacturer.name.toUpperCase() === "PACIFIC TRACK" &&
                                <div color="muted">
                                    {messages["devices_import_csv_file_instructions_pacific_track"]}
                                    <span
                                        className="ml-2 btn-link"
                                        onClick={() => {
                                            // Example data given in question text
                                            var data = [
                                                ['IMEI', 'ICCID', 'MSISDN']
                                            ];

                                            // Building the CSV from the Data two-dimensional array
                                            // Each column is separated by ";" and new line "\n" for next Grid
                                            var csvContent = '';
                                            data.forEach(function (infoArray, index) {
                                                let dataString = infoArray.join(',');
                                                csvContent += index < data.length ? dataString + '\n' : dataString;
                                            });

                                            var a = document.createElement('a');
                                            let mimeType = 'text/csv;encoding:utf-8'

                                            if (navigator.msSaveBlob) { // IE10
                                                navigator.msSaveBlob(new Blob([content], {
                                                    type: mimeType
                                                }), 'devicesPUI.csv');
                                            } else if (URL && 'download' in a) { //html5 A[download]
                                                a.href = URL.createObjectURL(new Blob([csvContent], {
                                                    type: mimeType
                                                }));
                                                a.setAttribute('download', 'devicesPacificTrack.csv');
                                                document.body.appendChild(a);
                                                a.click();
                                                document.body.removeChild(a);
                                            } else {
                                                location.href = 'data:application/octet-stream,' + encodeURIComponent(content); // only this mime type is supported
                                            }
                                        }}
                                    >
                                        {messages["devices_import_csv_file_download_sample"]}
                                    </span>
                                </div>
                            }
                            {
                                manufacturer.name.toUpperCase() === "ZONAR" &&
                                <div color="muted">
                                    {messages["devices_import_csv_file_instructions_zonar"]}
                                    <span
                                        className="ml-2 btn-link"
                                        onClick={() => {
                                            // Example data given in question text
                                            var data = [
                                                ['SERIAL']
                                            ];

                                            // Building the CSV from the Data two-dimensional array
                                            // Each column is separated by ";" and new line "\n" for next Grid
                                            var csvContent = '';
                                            data.forEach(function (infoArray, index) {
                                                let dataString = infoArray.join(',');
                                                csvContent += index < data.length ? dataString + '\n' : dataString;
                                            });

                                            var a = document.createElement('a');
                                            let mimeType = 'text/csv;encoding:utf-8'

                                            if (navigator.msSaveBlob) { // IE10
                                                navigator.msSaveBlob(new Blob([content], {
                                                    type: mimeType
                                                }), 'devicesZonar.csv');
                                            } else if (URL && 'download' in a) { //html5 A[download]
                                                a.href = URL.createObjectURL(new Blob([csvContent], {
                                                    type: mimeType
                                                }));
                                                a.setAttribute('download', 'devicesZonar.csv');
                                                document.body.appendChild(a);
                                                a.click();
                                                document.body.removeChild(a);
                                            } else {
                                                location.href = 'data:application/octet-stream,' + encodeURIComponent(content); // only this mime type is supported
                                            }
                                        }}
                                    >
                                        {messages["devices_import_csv_file_download_sample"]}
                                    </span>
                                </div>
                            }
                            {
                                manufacturer.name.toUpperCase() === "GENX" &&
                                <div color="muted">
                                    {messages["devices_import_csv_file_instructions_telitek"]}
                                    <span
                                        className="ml-2 btn-link"
                                        onClick={() => {
                                            // Example data given in question text
                                            var data = [
                                                ['SERIAL', 'IMEI', 'ICCID', 'MSISDN']
                                            ];

                                            // Building the CSV from the Data two-dimensional array
                                            // Each column is separated by ";" and new line "\n" for next Grid
                                            var csvContent = '';
                                            data.forEach(function (infoArray, index) {
                                                let dataString = infoArray.join(',');
                                                csvContent += index < data.length ? dataString + '\n' : dataString;
                                            });

                                            var a = document.createElement('a');
                                            let mimeType = 'text/csv;encoding:utf-8'

                                            if (navigator.msSaveBlob) { // IE10
                                                navigator.msSaveBlob(new Blob([content], {
                                                    type: mimeType
                                                }), 'devicesPUI.csv');
                                            } else if (URL && 'download' in a) { //html5 A[download]
                                                a.href = URL.createObjectURL(new Blob([csvContent], {
                                                    type: mimeType
                                                }));
                                                a.setAttribute('download', 'devicesGenx.csv');
                                                document.body.appendChild(a);
                                                a.click();
                                                document.body.removeChild(a);
                                            } else {
                                                location.href = 'data:application/octet-stream,' + encodeURIComponent(content); // only this mime type is supported
                                            }
                                        }}
                                    >
                                        {messages["devices_import_csv_file_download_sample"]}
                                    </span>
                                </div>
                            }
                            {
                                (manufacturer.name.toUpperCase() === "DIGITAL MATTER" || manufacturer.name.toUpperCase() === "LIGHTMETRICS") &&
                                <div color="muted">
                                    {messages["devices_import_csv_file_instructions_digital_matter"]}
                                    <span
                                        className="ml-2 btn-link"
                                        onClick={() => {
                                            // Example data given in question text
                                            var data = [
                                                ['IMEI']
                                            ];

                                            let name = 'digitalMatter.csv'
                                            if (manufacturer.name.toUpperCase() === "LIGHTMETRICS") {
                                                name = 'lightMetrics.csv'
                                            }
                                            var data = [
                                                ['IMEI']
                                            ];
                                            // Building the CSV from the Data two-dimensional array
                                            // Each column is separated by ";" and new line "\n" for next Grid
                                            var csvContent = '';
                                            data.forEach(function (infoArray, index) {
                                                let dataString = infoArray.join(',');
                                                csvContent += index < data.length ? dataString + '\n' : dataString;
                                            });

                                            var a = document.createElement('a');
                                            let mimeType = 'text/csv;encoding:utf-8'

                                            if (navigator.msSaveBlob) { // IE10
                                                navigator.msSaveBlob(new Blob([content], {
                                                    type: mimeType
                                                }), name);
                                            } else if (URL && 'download' in a) { //html5 A[download]
                                                a.href = URL.createObjectURL(new Blob([csvContent], {
                                                    type: mimeType
                                                }));
                                                a.setAttribute('download', name);
                                                document.body.appendChild(a);
                                                a.click();
                                                document.body.removeChild(a);
                                            } else {
                                                location.href = 'data:application/octet-stream,' + encodeURIComponent(content); // only this mime type is supported
                                            }
                                        }}
                                    >
                                        {messages["devices_import_csv_file_download_sample"]}
                                    </span>
                                </div>
                            }
                            {
                                manufacturer.name.toUpperCase() === "M2MD" &&
                                <div color="muted">
                                    {messages["devices_import_csv_file_instructions_m2md"]}
                                    <span
                                        className="ml-2 btn-link"
                                        onClick={() => {
                                            // Example data given in question text
                                            var data = [
                                                ['IMEI', 'ICCID']
                                            ];

                                            // Building the CSV from the Data two-dimensional array
                                            // Each column is separated by ";" and new line "\n" for next Grid
                                            var csvContent = '';
                                            data.forEach(function (infoArray, index) {
                                                let dataString = infoArray.join(',');
                                                csvContent += index < data.length ? dataString + '\n' : dataString;
                                            });

                                            var a = document.createElement('a');
                                            let mimeType = 'text/csv;encoding:utf-8'

                                            if (navigator.msSaveBlob) { // IE10
                                                navigator.msSaveBlob(new Blob([content], {
                                                    type: mimeType
                                                }), 'devicesM2MD.csv');
                                            } else if (URL && 'download' in a) { //html5 A[download]
                                                a.href = URL.createObjectURL(new Blob([csvContent], {
                                                    type: mimeType
                                                }));
                                                a.setAttribute('download', 'devicesM2MD.csv');
                                                document.body.appendChild(a);
                                                a.click();
                                                document.body.removeChild(a);
                                            } else {
                                                location.href = 'data:application/octet-stream,' + encodeURIComponent(content); // only this mime type is supported
                                            }
                                        }}
                                    >
                                        {messages["devices_import_csv_file_download_sample"]}
                                    </span>
                                </div>
                            }
                            {
                                manufacturer.name.toUpperCase() === "SMARTWITNESS" &&
                                <div color="muted">
                                    {messages["devices_import_csv_file_instructions_smartwitness"]}
                                     <span
                                        className="ml-2 btn-link"
                                        onClick={() => {
                                            // Example data given in question text
                                            var data = [
                                                ['DRID', 'ICCID']
                                            ];

                                            // Building the CSV from the Data two-dimensional array
                                            // Each column is separated by ";" and new line "\n" for next Grid
                                            var csvContent = '';
                                            data.forEach(function (infoArray, index) {
                                                let dataString = infoArray.join(',');
                                                csvContent += index < data.length ? dataString + '\n' : dataString;
                                            });

                                            var a = document.createElement('a');
                                            let mimeType = 'text/csv;encoding:utf-8'

                                            if (navigator.msSaveBlob) { // IE10
                                                navigator.msSaveBlob(new Blob([content], {
                                                    type: mimeType
                                                }), 'devicesSmartWitness.csv');
                                            } else if (URL && 'download' in a) { //html5 A[download]
                                                a.href = URL.createObjectURL(new Blob([csvContent], {
                                                    type: mimeType
                                                }));
                                                a.setAttribute('download', 'devicesSmartWitness.csv');
                                                document.body.appendChild(a);
                                                a.click();
                                                document.body.removeChild(a);
                                            } else {
                                                location.href = 'data:application/octet-stream,' + encodeURIComponent(content); // only this mime type is supported
                                            }
                                        }}
                                    >
                                        {messages["devices_import_csv_file_download_sample"]}
                                    </span>
                                </div>
                            }
                        </Grid>
                    </Grid>

                </Form>
            </Grid>
        );
    }

    //step 2 !isCSV calamp
    const renderInputFormManualCalamp = () => {
        return (
            <Form
                ref={formManualInputCalamp}
                onValidSubmit={() => {
                    //se valida que los imei ingresados no existan en otras subscriptions
                    let Devices = selectedItems;
                    let errors = []
                    let deviceSearchCriteriaArr = deviceSearchCriteria.split(/[\s,;\t\n]+/);
                    if (Devices.length < 300) {
                        if (deviceSearchCriteriaArr.length > 1) {
                            let criterias = [];

                            deviceSearchCriteriaArr.forEach(criteria => {
                                let escCriteria = criteria.trim();

                                let regx = /[^a-zA-Z0-9]/g;
                                escCriteria = escCriteria.replace(regx, '');

                                if (Devices && Devices.length) {
                                    for (let index in Devices) {
                                        let device = Devices[index];
                                        if (device.imei != escCriteria && device.esn != escCriteria && escCriteria !== '') {
                                            criterias.push(escCriteria);
                                        }
                                    }
                                } else if (escCriteria !== '') {
                                    criterias.push(escCriteria);
                                }
                            });

                            if (criterias.length) {
                                dispatch(devicesImportGetCalampDevicesInfo({ Imeis: criterias, simProviderAccount: simProviderAccount }));
                            }

                        } else {

                            let isValid = true;
                            for (let index in Devices) {
                                let device = Devices[index];
                                if (device.esn.toString() === deviceSearchCriteria) {
                                    isValid = false;
                                    errors.push({ message: "devices_import_imei_repeated_in_list", IMEI: device.imei });
                                    break;
                                }
                            }

                            if (isValid) {

                                dispatch(devicesImportGetCalampDevicesInfo({ Imeis: [deviceSearchCriteria], simProviderAccount: simProviderAccount }));
                            }
                        }
                    } else {
                        NotificationManager.error(messages["devices_import_error_limit_devices"], messages['devices_import_title'], 6000, null, null, '', null);

                    }
                    setErrors([...errors])
                }}
            >
                <Grid container>
                    <Grid xs={4}>
                        <Select
                            id="manual-calamps-sim-provider"
                            name="SIMProvider"
                            label={messages["devices_import_sim_provider_account"]}
                            placeholder={messages["devices_import_sim_provider_account"]}
                            value={simProviderAccount}
                            onChange={(value) => {
                                setSimProviderAccount(value);

                            }}
                            options={simProviderAccounts}
                            getOptionLabel={e => `${e.name}${e.simProvider ? ` - ${e.simProvider.name}` : ''}`}
                            getOptionValue={e => e.id}
                            textField="name"
                            valueField="id"
                            required
                            requiredMessage={messages['common_field_required']}
                        />
                    </Grid>
                    <Grid xs={5} style={{ marginLeft: 10 }}>
                        <Input
                            name="deviceSearchCriteria"
                            id="deviceSearchCriteria"
                            label={messages['devices_import_device_search_criteria']}
                            placeholder={messages["devices_import_device_search_criteria"]}
                            value={deviceSearchCriteria || ''}
                            onChange={(value) => {

                                setDeviceSearchCriteria(value)
                                //setErrorMEssageCalamp("")
                            }}
                            onKeyPress={event => {
                                if (event.key === 'Enter') {
                                    formManualInputCalamp?.current?.onSubmit(event)
                                }
                            }}

                            required
                            requiredMessage={messages['common_field_required']}
                            noMargin
                            maxLength={4000}
                        />
                    </Grid>
                    <Grid xs={2} style={{ marginLeft: 10, marginTop: 25 }}>
                        <Button
                            size="lg"
                            className="btn-dark-blue"
                            disabled={loading}
                            onClick={(event) => {
                                //formManualInputCalamp?.current?.onSubmit(event)
                            }}
                        >
                            {messages['devices_import_device_add']}
                        </Button>
                    </Grid>
                </Grid>
            </Form>
        );
    }

    //step 2 !isCSV geometris
    const renderInputFormManualGeometris = () => {
        return (
            <Form
                ref={formManualInputCalamp}
                onValidSubmit={() => {
                    //se valida que los imei ingresados no existan en otras subscriptions
                    let Devices = selectedItems;
                    let errors = []
                    let deviceSearchCriteriaArr = deviceSearchCriteria.split(/[\s,;\t\n]+/);
                    if (Devices.length < 300) {
                        if (deviceSearchCriteriaArr.length > 1) {
                            let criterias = [];

                            deviceSearchCriteriaArr.forEach(criteria => {
                                let escCriteria = criteria.trim();

                                let regx = /[^a-zA-Z0-9]/g;
                                escCriteria = escCriteria.replace(regx, '');

                                if (Devices && Devices.length) {
                                    for (let index in Devices) {
                                        let device = Devices[index];

                                        if (device.imei != escCriteria && device.esn != escCriteria && escCriteria !== '') {
                                            criterias.push(escCriteria);
                                        }
                                    }
                                } else if (escCriteria !== '') {
                                    criterias.push(escCriteria);
                                }
                            });

                            if (criterias.length) {
                                dispatch(devicesImportGetGeometrisDevicesInfo({ Imeis: criterias, simProviderAccount: simProviderAccount }));
                            }

                        } else {

                            let isValid = true;
                            for (let index in Devices) {
                                let device = Devices[index];
                                if (device.esn.toString() === deviceSearchCriteria) {
                                    isValid = false;
                                    errors.push({ message: "devices_import_imei_repeated_in_list", IMEI: device.imei });
                                    break;
                                }
                            }

                            if (isValid) {

                                dispatch(devicesImportGetGeometrisDevicesInfo({ Imeis: [deviceSearchCriteria], simProviderAccount: simProviderAccount }));
                            }
                        }
                    } else {
                        NotificationManager.error(messages["devices_import_error_limit_devices"], messages['devices_import_title'], 6000, null, null, '', null);

                    }
                    setErrors([...errors])
                }}
            >
                <Grid container>
                    <Grid xs={4}>
                        <Select
                            id="manual-geometris-sim-provider"
                            name="SIMProvider"
                            label={messages["devices_import_sim_provider_account"]}
                            placeholder={messages["devices_import_sim_provider_account"]}
                            value={simProviderAccount}
                            onChange={(value) => {
                                setSimProviderAccount(value);
                            }}
                            options={simProviderAccounts}
                            getOptionLabel={e => `${e.name}${e.simProvider ? ` - ${e.simProvider.name}` : ''}`}
                            getOptionValue={e => e.id}
                            textField="name"
                            valueField="id"
                            required
                            requiredMessage={messages['common_field_required']}
                        />
                    </Grid>
                    <Grid xs={5} style={{ marginLeft: 10 }}>
                        <Input
                            name="deviceSearchCriteria"
                            id="deviceSearchCriteria"
                            label={messages['devices_import_device_search_criteria']}
                            placeholder={messages["devices_import_device_search_criteria"]}
                            value={deviceSearchCriteria || ''}
                            onChange={(value) => {

                                setDeviceSearchCriteria(value)
                                //setErrorMEssageCalamp("")
                            }}
                            onKeyPress={event => {
                                if (event.key === 'Enter') {
                                    formManualInputCalamp?.current?.onSubmit(event)
                                }
                            }}

                            required
                            requiredMessage={messages['common_field_required']}
                            noMargin
                            maxLength={4000}
                        />
                    </Grid>
                    <Grid xs={2} style={{ marginLeft: 10, marginTop: 25 }}>
                        <Button
                            size="lg"
                            className="btn-dark-blue"
                            disabled={loading}
                            onClick={(event) => {
                                //formManualInputCalamp?.current?.onSubmit(event)
                            }}
                        >
                            {messages['devices_import_device_add']}
                        </Button>
                    </Grid>
                </Grid>
            </Form>
        );
    }

    //step 2 !isCSV vidfleet
    const renderInputFormManualVidFleet = () => {
        return (
            <Form
                ref={formManualInputVidFleet}
                onValidSubmit={() => {
                    let Devices = selectedItems;
                    let errors = []
                    let deviceSearchCriteriaArr = deviceSearchCriteria.split(/[\s,;\t\n]+/);
                    let validateDuplicate = false
                    let criterias = [];

                    deviceSearchCriteriaArr.forEach(criteria => {
                        let escCriteria = criteria.trim();

                        let regx = /[^a-zA-Z0-9]/g;
                        escCriteria = escCriteria.replace(regx, '');

                        if (Devices && Devices.length) {

                            let validate = Devices.some((de) => de.esn === escCriteria);

                            if (!validate)
                                criterias.push(escCriteria);
                            else
                                validateDuplicate = true;


                        } else {

                            criterias.push(escCriteria);
                        }
                    });

                    criterias = [...new Set(criterias)];

                    criterias.map((item) => {
                        if (item.length > 0) {
                            let currentSimProvider = simProviderAccount
                            Devices.push({
                                esn: item,
                                label: item,
                                simProviderAccount: currentSimProvider,
                            })
                        }
                    })
                    setSelectedItems([...Devices]);
                    setDeviceSearchCriteria("");
                    if (validateDuplicate)
                        NotificationManager.error(messages["devices_import_device_repeated_in_list"], messages['devices_import_title'], 6000, null, null, '', null);

                }}
            >
                <Grid container>
                    <Grid xs={4}>
                        <Select
                            id="manual-vidFleet-sim-provider"
                            name="SIMProvider"
                            label={messages["devices_import_sim_provider_account"]}
                            placeholder={messages["devices_import_sim_provider_account"]}
                            value={simProviderAccount}
                            onChange={(value) => {
                                setSimProviderAccount(value);
                            }}
                            options={simProviderAccounts}
                            getOptionLabel={e => `${e.name}${e.simProvider ? ` - ${e.simProvider.name}` : ''}`}
                            getOptionValue={e => e.id}
                            textField="name"
                            valueField="id"
                            required
                            requiredMessage={messages['common_field_required']}
                        />
                    </Grid>


                    <Grid xs={5} style={{ marginLeft: 10 }}>
                        <Input
                            type="text"
                            id="ESN"
                            maxLength={20}
                            label={messages["devices_import_serial"]}
                            placeholder={messages["devices_import_serial"]}
                            value={deviceSearchCriteria || ''}
                            onChange={(value) => {
                                setDeviceSearchCriteria(value)
                            }}
                            onKeyPress={event => {
                                if (event.key === 'Enter') {
                                    focusNextControl(event);
                                }
                            }}

                            noBlurValidation
                            required
                            requiredMessage={messages['common_field_required']}
                            minLengthMessage={messages["devices_import_valid_serial_8_minlength"]}
                            autoComplete="new-password"
                        />
                    </Grid>

                    <Grid xs={2} style={{ marginLeft: 10, marginTop: 25 }}>
                        <Button
                            id="btnAdd"
                            className="btn-dark-blue"
                            onClick={(event) => {
                            }}
                        >
                            {messages['common_add']}
                        </Button>
                    </Grid>
                </Grid>
            </Form>
        );
    }

    //step 2 !isCSV others
    const renderInputFormManualOthers = () => {
        return (
            <Form
                ref={formManualInputOthers}
                onValidSubmit={() => {
                    let dvcs = selectedItems.slice();
                    let dev = { ...device, Error: 0 };
                    dev.deviceModel = deviceModel;
                    dev.simProviderAccount = simProviderAccount;

                    if (manufacturer.name.toUpperCase() !== "VidFleet".toUpperCase()) {
                        let devicesProcess = [];
                        let errors = [];
                        if (manufacturer?.name?.toUpperCase() === "M2MD".toUpperCase()) 
                            dev.esn = dev.imei;

                        dev.label = dev.esn ? dev.esn : dev.imei;
                        console.log("Device to process: ", dev)

                        if (
                            manufacturer.name.toUpperCase() === "Global Star".toUpperCase() ||
                            manufacturer.name.toUpperCase() === "Geometris".toUpperCase() ||
                            manufacturer.name.toUpperCase() === "Queclink".toUpperCase() ||
                            manufacturer.name.toUpperCase() === "TopFly".toUpperCase() ||
                            manufacturer.name.toUpperCase() === "Positioning Universal".toUpperCase()
                        ) {

                            let multipleDevices = dev.esn.split(/[\s,;\t\n]+/)
                            multipleDevices.map(x => {
                                if (x != " " && x.length > 2 && !devicesProcess.find(y => y.esn === x))
                                    devicesProcess.push({ ...dev, imei: x, label: x, esn: x, Error: 0 })
                            })
                        }
                        else
                            devicesProcess.push(dev);

                        devicesProcess.map(x => {

                            let response = true;
                            for (let i = 0; i < dvcs.length; i++) {
                                let devItem = dvcs[i];
                                if (x.imei && devItem.imei === x.imei) {
                                    errors.push({ message: 'devices_import_valid_duplicated_imei', imei: x.imei || x.esn });
                                    response = false;
                                }
                                else if (x.esn && devItem.esn === x.esn) {
                                    errors.push({ message: manufacturer.name.toUpperCase() === "CerebrumX".toUpperCase() ? 'devices_import_valid_duplicated_vin' : 'devices_import_valid_duplicated_esn', imei: x.imei || x.esn });
                                    response = false;
                                }
                                else if (devItem.iccid && x.iccid && devItem.iccid === x.iccid) {
                                    errors.push({ message: 'devices_import_valid_duplicated_iccid', imei: x.imei || x.esn });
                                    response = false;
                                }
                                else if (devItem.msisdn && x.msisdn && devItem.msisdn === x.msisdn) {
                                    errors.push({ message: 'devices_import_valid_duplicated_msisdn', imei: x.imei || x.esn });
                                    response = false;
                                }
                            };

                            if (response) {
                                dvcs.unshift(x);
                            }
                        })

                        setDevice({ imei: null, esn: null, iccid: null, msisdn: null })
                        setSelectedItems([...dvcs]);
                        setErrors([...errors])
                    }

                }}
            >
                <Grid container>
                    {
                        manufacturer.name.toUpperCase() !== "CEREBRUMX".toUpperCase() &&
                        manufacturer.name.toUpperCase() !== "Zonar".toUpperCase() &&
                        manufacturer.name.toUpperCase() !== "LightMetrics".toUpperCase() &&
                        <Grid xs={5} style={{ marginLeft: 10, marginTop: 10 }}>
                            <Select
                                id="import-device-type"
                                label={messages["devices_import_device_type"]}
                                placeholder={messages["devices_import_device_type"]}
                                value={deviceModel}
                                onChange={(value) => {
                                    setDeviceModel(value);
                                    dispatch(devicesImportGetDeviceModel(value.id));
                                }}
                                loading={loadingDeviceModels}
                                options={deviceModels && deviceModels.filter(x => x.manufacturerId === manufacturer.id) || []}
                                textField="name"
                                valueField="id"
                                required
                                requiredMessage={messages['common_field_required']}
                            />
                        </Grid>
                    }

                    {
                        manufacturer.name.toUpperCase() !== "Global Star".toUpperCase() &&
                        //manufacturer.name.toUpperCase() !== "SmartWitness".toUpperCase() &&
                        manufacturer.name.toUpperCase() !== "CEREBRUMX".toUpperCase() &&
                        manufacturer.name.toUpperCase() !== "Zonar".toUpperCase() &&
                        manufacturer.name.toUpperCase() !== "LightMetrics".toUpperCase() &&
                        manufacturer.name.toUpperCase() !== "M2MD".toUpperCase() &&
                        <Grid xs={5} style={{ marginLeft: 10, marginTop: 10 }}>
                            <Select
                                id="import-simp-account"
                                label={messages["devices_import_sim_provider_account"]}
                                placeholder={messages["devices_import_sim_provider_account"]}
                                value={simProviderAccount}
                                onChange={(value) => {
                                    setSimProviderAccount(value)
                                }}
                                options={simProviderAccounts}
                                getOptionLabel={e => `${e.name}${e.simProvider ? ` - ${e.simProvider.name}` : ''}`}
                                getOptionValue={e => e.id}
                                textField="name"
                                valueField="id"
                                required
                                requiredMessage={messages['common_field_required']}
                            />
                        </Grid>
                    }

                    {
                        manufacturer.name.toUpperCase() !== "Pacific Track".toUpperCase() &&
                        manufacturer.name.toUpperCase() !== "Digital Matter".toUpperCase() &&
                        manufacturer.name.toUpperCase() !== "LightMetrics".toUpperCase() &&
                        manufacturer.name.toUpperCase() !== "M2MD".toUpperCase() &&
                        <Grid xs={5} style={{ marginLeft: 10, marginTop: 10 }}>
                            <Input
                                type="text"
                                name="ESN"
                                id="ESN"
                                maxLength={(manufacturer.name.toUpperCase() === "SmartWitness".toUpperCase() || manufacturer.name.toUpperCase() === "Telitek".toUpperCase() || manufacturer.name.toUpperCase() === "Queclink".toUpperCase()) ? 15 : (manufacturer.name.toUpperCase() === "TopFly".toUpperCase()) ? 16 : manufacturer.name.toUpperCase() === "CEREBRUMX".toUpperCase() ? 17 : 20}
                                minLength={(manufacturer.name.toUpperCase() === "SmartWitness".toUpperCase() || manufacturer.name.toUpperCase() === "Geometris".toUpperCase()) ? 12 :
                                    (manufacturer.name.toUpperCase() === "Positioning Universal".toUpperCase() || manufacturer.name.toUpperCase() === "Queclink".toUpperCase() || manufacturer.name.toUpperCase() === "TopFly".toUpperCase()) ? 15 : manufacturer.name.toUpperCase() === "CEREBRUMX".toUpperCase() ? 17 : 3}
                                label={
                                    (
                                        manufacturer.name.toUpperCase() !== "Geometris".toUpperCase() &&
                                        manufacturer.name.toUpperCase() !== "Positioning Universal".toUpperCase() &&
                                        manufacturer.name.toUpperCase() !== "Queclink".toUpperCase() &&
                                        manufacturer.name.toUpperCase() !== "TopFly".toUpperCase()
                                    )
                                        ? manufacturer.name.toUpperCase() === "SmartWitness".toUpperCase()
                                            ? messages["devices_import_serial_drid"] : manufacturer.name.toUpperCase() === "CEREBRUMX".toUpperCase() ? messages["devices_import_vin"] : messages["devices_import_serial"]
                                        : messages["devices_import_serial_imei"]
                                }
                                placeholder={
                                    (
                                        manufacturer.name.toUpperCase() !== "Geometris".toUpperCase() &&
                                        manufacturer.name.toUpperCase() !== "Positioning Universal".toUpperCase() &&
                                        manufacturer.name.toUpperCase() !== "Queclink".toUpperCase() &&
                                        manufacturer.name.toUpperCase() !== "TopFly".toUpperCase()
                                    )
                                        ? manufacturer.name.toUpperCase() === "SmartWitness".toUpperCase()
                                            ? messages["devices_import_serial_drid"] : manufacturer.name.toUpperCase() === "CerebrumX".toUpperCase() ? messages["devices_import_vin"] : messages["devices_import_serial"]
                                        : messages["devices_import_serial_imei"]
                                }


                                value={device.esn || ""}
                                onChange={(value) => {
                                    let dev = device;
                                    dev.esn = value
                                    if (manufacturer.name.toUpperCase() === "Zonar".toUpperCase())
                                        dev.imei = value
                                    setDevice({ ...dev })
                                }}
                                required
                                requiredMessage={messages['common_field_required']}
                                minLengthMessage={(
                                    manufacturer.name.toUpperCase() !== "Geometris".toUpperCase() &&
                                    manufacturer.name.toUpperCase() !== "Positioning Universal".toUpperCase() &&
                                    manufacturer.name.toUpperCase() !== "Queclink".toUpperCase() &&
                                    manufacturer.name.toUpperCase() !== "TopFly".toUpperCase()
                                )
                                    ? manufacturer.name.toUpperCase() === "SmartWitness".toUpperCase() ? messages["devices_import_valid_serial_drid_minlength"]
                                        : manufacturer.name.toUpperCase() === "Geometris".toUpperCase() ? messages["devices_import_valid_serial_imei_minlength_geo"]
                                            : (manufacturer.name.toUpperCase() === "Queclink".toUpperCase() || manufacturer.name.toUpperCase() === "TopFly".toUpperCase()) ? messages["devices_import_valid_serial_imei_minlength_queclink"]
                                                : manufacturer.name.toUpperCase() === "CerebrumX".toUpperCase() ? messages["devices_import_valid_vin_minlength"]
                                                    : messages["devices_import_valid_serial_minlength"] : messages["devices_import_valid_serial_imei_minlength"]
                                }
                                noBlurValidation
                                autoComplete="new-password"
                            />
                        </Grid>
                    }
                    {
                        manufacturer.name.toUpperCase() !== "Global Star".toUpperCase() &&
                        manufacturer.name.toUpperCase() !== "Geometris".toUpperCase() &&
                        manufacturer.name.toUpperCase() !== "Positioning Universal".toUpperCase() &&
                        manufacturer.name.toUpperCase() !== "SmartWitness".toUpperCase() &&
                        manufacturer.name.toUpperCase() !== "Queclink".toUpperCase() &&
                        manufacturer.name.toUpperCase() !== "TopFly".toUpperCase() &&
                        manufacturer.name.toUpperCase() !== "CerebrumX".toUpperCase() &&
                        manufacturer.name.toUpperCase() !== "Zonar".toUpperCase() &&
                        <Grid xs={5} style={{ marginLeft: 10, marginTop: 10 }}>
                            <Input
                                type="text"
                                name="IMEI"
                                id="IMEI"
                                label={messages["devices_import_imei"]}
                                placeholder={messages["devices_import_imei"]}
                                value={device.imei || ""}
                                onChange={(value) => {
                                    let dev = device;
                                    dev.imei = value
                                    if (manufacturer.name.toUpperCase() === "Pacific Track".toUpperCase() || manufacturer.name.toUpperCase() === "Digital Matter".toUpperCase() || manufacturer.name.toUpperCase() === "LightMetrics".toUpperCase())
                                        dev.esn = value
                                    setDevice({ ...dev })
                                }}
                                maxLength={16}
                                maxLengthMessage={" "}
                                regex={"^[0-9]*$"}
                                required
                                requiredMessage={messages['common_field_required']}
                            />
                        </Grid>
                    }



                    {
                        manufacturer.name.toUpperCase() !== "Global Star".toUpperCase() &&
                        //manufacturer.name.toUpperCase() !== "SmartWitness".toUpperCase() &&
                        manufacturer.name.toUpperCase() !== "CEREBRUMX".toUpperCase() &&
                        manufacturer.name.toUpperCase() !== "Zonar".toUpperCase() &&
                        manufacturer.name.toUpperCase() !== "Digital Matter".toUpperCase() &&
                        manufacturer.name.toUpperCase() !== "LightMetrics".toUpperCase() &&
                        (simProviderAccount || manufacturer.name.toUpperCase() === "M2MD".toUpperCase()) &&
                        <Grid xs={5} style={{ marginLeft: 10, marginTop: 10 }}>
                            <Input
                                name="ICCID"
                                id="ICCID"
                                label={messages["devices_import_sim"]}
                                placeholder={messages["devices_import_sim"]}
                                value={device.iccid || ""}
                                onChange={(value) => {
                                    let dev = device
                                    dev.iccid = value
                                    setDevice({ ...dev })
                                }}
                                type="text"
                                regex={"^[a-zA-Z0-9_.-]*$"} //only text and numbers
                                maxLength={20}
                                minLength={!simProviderAccount?.name?.toUpperCase().includes("LATAM") ? 19 : 15}
                                minLengthMessage={messages['devices_import_valid_iccid_minlength']}
                                maxLengthMessage={" "}
                                required
                                requiredMessage={messages['common_field_required']}
                            />
                        </Grid>
                    }
                    {
                        manufacturer.name.toUpperCase() !== "Global Star".toUpperCase() &&
                        //manufacturer.name.toUpperCase() !== "SmartWitness".toUpperCase() &&
                        manufacturer.name.toUpperCase() !== "VidFleet".toUpperCase() &&
                        manufacturer.name.toUpperCase() !== "CEREBRUMX".toUpperCase() &&
                        manufacturer.name.toUpperCase() !== "Zonar".toUpperCase() &&
                        manufacturer.name.toUpperCase() !== "Digital Matter".toUpperCase() &&
                        manufacturer.name.toUpperCase() !== "LightMetrics".toUpperCase() &&
                        manufacturer.name.toUpperCase() !== "M2MD".toUpperCase() &&
                        simProviderAccount &&
                        simProviderAccount?.simProvider?.name.toUpperCase() !== "AT&T" &&
                        <Grid xs={5} style={{ marginLeft: 10, marginTop: 10 }}>
                            <Input
                                type="text"
                                name="MSISDN"
                                id="MSISDN"
                                label={messages["devices_import_phone"]}
                                placeholder={messages["devices_import_phone"]}
                                value={device.msisdn || ""}
                                onChange={(value) => {
                                    let dev = device
                                    dev.msisdn = value
                                    setDevice({ ...dev })
                                }}
                                regex={"^[0-9]*$"}
                                maxLength={15}
                                minLength={8}
                                minLengthMessage={messages['devices_import_valid_msisdn_minlength']}
                                maxLengthMessage={" "}
                                required={!(manufacturer.name.toUpperCase() === "SmartWitness".toUpperCase())}
                                requiredMessage={messages['common_field_required']}

                            />
                        </Grid>
                    }
                    {
                        manufacturer.name.toUpperCase() !== "Global Star".toUpperCase() &&
                        //manufacturer.name.toUpperCase() !== "SmartWitness".toUpperCase() &&
                        manufacturer.name.toUpperCase() !== "VidFleet".toUpperCase() &&
                        manufacturer.name.toUpperCase() !== "CEREBRUMX".toUpperCase() &&
                        manufacturer.name.toUpperCase() !== "Zonar".toUpperCase() &&
                        manufacturer.name.toUpperCase() !== "Digital Matter".toUpperCase() &&
                        manufacturer.name.toUpperCase() !== "LightMetrics".toUpperCase() &&
                        manufacturer.name.toUpperCase() !== "M2MD".toUpperCase() &&
                        simProviderAccount &&
                        simProviderAccount?.simProvider?.name.toUpperCase() === "AT&T" &&
                        <Grid xs={5} style={{ marginLeft: 10, marginTop: 10 }}>
                            <Input
                                type="text"
                                name="MSISDN"
                                id="MSISDN"
                                label={messages["devices_import_phone"]}
                                placeholder={messages["devices_import_phone"]}
                                value={device.msisdn || ""}
                                onChange={(value) => {
                                    let dev = device
                                    dev.msisdn = value
                                    setDevice({ ...dev })
                                }}
                                regex={"^[0-9]*$"}
                                maxLength={15}
                                minLength={8}
                                minLengthMessage={messages['devices_import_valid_msisdn_minlength']}
                                maxLengthMessage={" "}
                                requiredMessage={messages['common_field_required']}

                            />
                        </Grid>
                    }
                    {
                        manufacturer.name.toUpperCase() === "CEREBRUMX".toUpperCase() &&
                        <Grid xs={5} style={{ marginLeft: 10, marginTop: 10 }}>
                            <Select
                                id="package-name"
                                label={messages["devices_import_package_name"]}
                                placeholder={messages["devices_import_package_name"]}
                                value={getCerebrumXPackages(messages).find(x => x.id === packageName?.id)}
                                onChange={(value) => {
                                    setPackageName(value);
                                    let dev = device;
                                    dev.packageName = value.id
                                    setDevice({ ...dev })
                                }}
                                options={getCerebrumXPackages(messages) || []}
                                textField="name"
                                valueField="id"
                                required
                                requiredMessage={messages['common_field_required']}
                            />
                        </Grid>
                    }
                    <Grid xs={12} className="text-left" style={{ marginLeft: 10, marginTop: 10 }}>
                        <Button
                            id="btnAdd"
                            className="btn-dark-blue"
                            onClick={(event) => {
                                //formManualInputOthers?.current?.onSubmit(event)
                            }}
                        >
                            {messages['common_add']}
                        </Button>
                    </Grid>
                </Grid>
            </Form>
        );
    }

    //step 2 !isCSV
    const renderInputFormManufactuerManual = () => {
        let manufacturerName = manufacturer.name.toUpperCase()
        switch (manufacturerName) {
            case "CALAMP":
                return renderInputFormManualCalamp();
                break;
            case "GEOMETRIS":
                return renderInputFormManualGeometris();
                break;
            case "VIDFLEET":
                return renderInputFormManualVidFleet();
                break;
            default:
                return renderInputFormManualOthers();
                break;
        }
    }

    const renderInputFormManual = () => {
        return (
            <Grid container>
                <Grid xs={12}>
                    {renderInputFormManufactuerManual()}
                </Grid>
                <Grid xs={12}>
                    {
                        errors?.length > 0 &&
                        <Alert severity="error">
                            {`${messages["devices_import_calamp_errors"]}: `}
                            <br />
                            <br />
                            <ul>
                                {
                                    errors.map((x, key) => {
                                        return (
                                            <li key={key}>
                                                {
                                                    `${manufacturer.name.toUpperCase() === "CerebrumX".toUpperCase() ? 'VIN' : 'ESN/IMEI'}: ${x.esn || x.imei} - ${x.partNumber ? ` ${x.partNumber} -` : ``} ${messages[x.message]}`
                                                }
                                            </li>
                                        )
                                    })
                                }
                            </ul>
                        </Alert>
                    }
                </Grid>
                <Grid xs={12} style={{ marginLeft: 10, marginTop: 10 }}>
                    <Table
                        ref={tableRefInputManual}
                        columns={getColumnsManual()}
                        data={selectedItems}
                        height={380}
                        hidePagination
                        disableItemSelection
                    />
                </Grid>
                <Grid xs={12}>
                    {
                        simProviderAccount &&
                        manufacturer.name.toUpperCase() !== "Global Star".toUpperCase() &&
                        //manufacturer.name.toUpperCase() !== "SmartWitness".toUpperCase() &&
                        manufacturer.name.toUpperCase() !== "VidFleet".toUpperCase() &&
                        manufacturer.name.toUpperCase() !== "Digatal Matter".toUpperCase() &&
                        manufacturer.name.toUpperCase() !== "M2MD".toUpperCase() &&
                        selectedItems.filter(x => x.simProviderAccount && (x?.simProviderAccount?.simProvider?.name.toUpperCase() === "AT&T")).length > 0 &&
                        <Button size="lg" className="btn-dark-blue" style={{ marginTop: "1px", marginBottom: "15px" }}
                            onClick={() => {
                                NotificationManager.info(messages["devices_import_fetching_phone_numbers"], "", 8000, null, null, '', null);
                                dispatch(devicesImportLoadPhoneNumbers(selectedItems));
                            }}
                            disabled={loading}
                        >
                            {messages["devices_import_get_phone_numbers"]}
                        </Button>
                    }
                </Grid>
            </Grid>
        )
    }

    // step 3 isCSV
    const renderSummaryCVS = () => {
        return (
            <Grid>
                <Grid>
                    <Grid xs={12} className="mb-3">
                        <h4>
                            {`${messages["devices_import_summary_title"]} (${devices?.length || 0})`}
                        </h4>
                    </Grid>
                </Grid>
                <Grid>
                    {
                        reference &&
                        <Grid xs={6} className="mb-3">
                            <span className="mr-1">
                                <strong>{messages['devices_import_ref_number']}:</strong>
                            </span>
                            {reference}
                        </Grid>

                    }
                </Grid>
                {
                    error === 1 &&
                    <Grid>
                        <Grid xs={12} className="mb-3">
                            <Alert severity="error">
                                {messages[errorMessage]}
                            </Alert>
                        </Grid>
                    </Grid>
                }
                <Grid className="mt-2">
                    <Grid>
                        <Grid xs={12}>
                            {
                                //devices && devices.length > 0 &&
                                <Table
                                    ref={tableRefCSVSymmary}
                                    onSelectedItems={(items) => setSelectedItems(items)}
                                    columns={summaryCSVGetColumns()}
                                    data={devices}
                                    height={600}
                                    hidePagination
                                />
                            }
                        </Grid>
                    </Grid>
                </Grid>

                {
                    isCSV &&
                    simProviderAccount &&
                    (simProviderAccount?.simProvider?.name?.toUpperCase() === "AT&T") &&
                    manufacturer?.name?.toUpperCase() !== "Vidfleet".toUpperCase() &&
                    manufacturer?.name?.toUpperCase() !== "Digital Matter".toUpperCase() &&
                    manufacturer?.name?.toUpperCase() !== "LightMetrics".toUpperCase() &&
                    manufacturer?.name?.toUpperCase() !== "M2MD".toUpperCase() &&
                    <Grid>
                        <Grid xs={12} className="mb-3">
                            <Button size="lg" className="btn-dark-blue" style={{ marginTop: "1px" }}
                                onClick={() => {
                                    setError(0)
                                    setErrorMessage(null);
                                    NotificationManager.info(messages["devices_import_fetching_phone_numbers"]);
                                    dispatch(devicesImportLoadPhoneNumbers(devices, simProviderAccount));
                                }}
                                disabled={loading}
                            >
                                {messages['devices_import_get_phone_numbers']}
                            </Button>
                        </Grid>
                    </Grid>
                }

            </Grid >
        )
    }

    // step 4 isCSV - step 3 !isCSV
    const renderFeaturesSelecction = () => {

        return (
            <Grid style={{ marginBottom: 10 }}>
                <Grid container>
                    <Grid xs={4} className="pb-2">
                        <div className="d-flex">
                            <div style={{ width: "100%" }}>
                                <b>
                                    <h3>
                                        {messages["devices_import_features"]}
                                    </h3>
                                </b>
                            </div>
                        </div>
                    </Grid>
                    <Grid xs={4} className="pb-2">
                        <div className="d-flex">
                            <div style={{ width: "100%" }}>

                                <b>
                                    <h3>
                                        {messages["devices_import_status"]}
                                    </h3>
                                </b>

                            </div>
                        </div>
                    </Grid>
                    <Grid xs={4} className="pb-2">
                        <div className="d-flex">
                            <div style={{ width: "100%" }}>

                                <Button
                                    size="lg"
                                    className="btn btn-dark-blue"
                                    onClick={() => {
                                        markFeatures(true);
                                    }}
                                >
                                    {messages['devices_import_enable']}
                                </Button>
                                <Button
                                    style={{ marginLeft: "5px" }}
                                    size="lg"
                                    className="btn btn-dark-blue"
                                    onClick={() => {
                                        markFeatures(false);
                                    }}
                                >
                                    {messages['devices_import_disable']}
                                </Button>
                            </div>
                        </div>
                    </Grid>
                </Grid>
                {
                    featuresOptions && featuresOptions.map((item, index) => {
                        return (
                            <div key={index}>
                                {
                                    features[item.key] &&
                                    <Grid container>
                                        <Grid xs={4} className="pb-2">
                                            <div className="d-flex">
                                                <div>
                                                    <Checkbox
                                                        className="itemCheck mb-0"
                                                        type="checkbox"
                                                        id={`${item.field}-all-${index}`}
                                                        value={
                                                            selectedItems.filter(x => x[item.field] && x[item.field] === true).length === features[item.keyDevices].length
                                                        }
                                                        onChange={() => {
                                                            let feat = features;
                                                            let dvs = feat[item.keyDevices];
                                                            let dvsSelected = selectedItems;
                                                            if (dvs.filter(x => x[item.field] && x[item.field] === true).length === dvs.length) {
                                                                dvs.map((itemDev, key) => {
                                                                    itemDev[item.field] = false;
                                                                    let indexSelected = dvsSelected.findIndex(x => x.esn === itemDev.esn);
                                                                    dvsSelected[indexSelected][item.field] = false;

                                                                    if (item.field === "vbus" || item.field === "jbus") {
                                                                        dvsSelected[indexSelected]["useEcuOdometer"] = false;
                                                                        dvsSelected[indexSelected]["useEcuSpeed"] = false;
                                                                        dvsSelected[indexSelected]["useEcuVin"] = false;

                                                                    }

                                                                })
                                                            } else {
                                                                dvs.map((itemDev, key) => {
                                                                    itemDev[item.field] = true;
                                                                    let indexSelected = dvsSelected.findIndex(x => x.esn === itemDev.esn);
                                                                    if ((item.field === "useEcuOdometer" || item.field === "useEcuSpeed" || item.field === "useEcuVin") &&
                                                                        (!dvsSelected[indexSelected]["jbus"] && !dvsSelected[indexSelected]["vbus"])) {
                                                                        dvsSelected[indexSelected][item.field] = false;
                                                                    } else {
                                                                        dvsSelected[indexSelected][item.field] = true;
                                                                    }

                                                                    if (item.field === "vbus") {
                                                                        itemDev["jbus"] = false;
                                                                        dvsSelected[indexSelected]["jbus"] = false;
                                                                    } else if (item.field === "jbus") {
                                                                        itemDev["vbus"] = false;
                                                                        dvsSelected[indexSelected]["vbus"] = false;
                                                                    }
                                                                })
                                                            }
                                                            feat[item.keyDevices] = dvs;
                                                            setFeatures({ ...feat })
                                                            setSelectedItems([...dvsSelected])
                                                        }}
                                                    />
                                                </div>
                                                <div style={{ width: "100%", marginTop: 10 }}>
                                                    <a
                                                        style={{ textDecoration: "underline" }}
                                                        onClick={() => {
                                                            let feat = features;
                                                            feat[item.keyOpen] = !feat[item.keyOpen];
                                                            setFeatures({ ...feat })
                                                        }}>
                                                        {
                                                            messages[item.label]
                                                        }
                                                    </a>
                                                </div>
                                            </div>
                                        </Grid>
                                        <Grid xs={4} className="pb-2">
                                            <p className="text-muted mb-2">
                                                {
                                                    ` ${features[item.keyDevices].filter(x => x[item.field] && x[item.field] === true).length} ${messages["devices_import_of"]} ${features[item.keyDevices].length} ${messages["devices_import_devices_enabled"]}`
                                                }
                                            </p>
                                        </Grid>
                                    </Grid>
                                }
                                {
                                    features[item.key] &&
                                    features[item.keyOpen] &&
                                    features[item.keyDevices].map((dataItem, key) => {
                                        let deviceIndex = selectedItems.findIndex(x => x.esn === dataItem.esn);
                                        let device = selectedItems[deviceIndex];
                                        let checked = device[item.field] ? true : false;
                                        let disabled = false;
                                        if ((item.field === "useEcuOdometer" || item.field === "useEcuSpeed" || item.field === "useEcuVin") && (!device["jbus"] && !device["vbus"])) {
                                            disabled = true;
                                        }

                                        return (
                                            <Grid container key={key}>
                                                <Grid xs={4} style={{ marginLeft: "30px" }}>
                                                    <div className="d-flex">
                                                        <div >
                                                            {
                                                                item.key !== "showLinkedMode" &&
                                                                <Checkbox
                                                                    className="itemCheck mb-0"
                                                                    type="checkbox"
                                                                    id={`${item.keyDevices}_${key}`}
                                                                    value={checked}
                                                                    label={dataItem.esn}
                                                                    disabled={disabled}
                                                                    onChange={(event) => {
                                                                        let dvcs = selectedItems;
                                                                        device[item.field] = !checked;
                                                                        if (!checked) {
                                                                            if (item.field === "vbus") {
                                                                                device["jbus"] = checked;
                                                                            } else if (item.field === "jbus") {
                                                                                device["vbus"] = checked;
                                                                            }
                                                                        }
                                                                        dvcs[deviceIndex] = device;
                                                                        setSelectedItems(dvcs);
                                                                        setFeatures({ ...features })

                                                                    }}
                                                                />
                                                            }
                                                            {
                                                                item.key === "showLinkedMode" &&
                                                                <div className="d-flex">
                                                                    <ToggleSwitch
                                                                        id={`${item.keyDevices}_${key}`}
                                                                        blueToggle={true}
                                                                        extraLarge={true}
                                                                        optionLabels={[messages["devices_import_camera_paired_mode"], messages["devices_import_camera_gps"]]}
                                                                        checked={checked}
                                                                        onChange={() => {
                                                                            let dvcs = selectedItems;
                                                                            device[item.field] = !checked;
                                                                            dvcs[deviceIndex] = device;
                                                                            setSelectedItems(dvcs);
                                                                            setFeatures({ ...features })
                                                                        }}
                                                                    />
                                                                    <div style={{ marginTop: 5 }}>
                                                                        {dataItem.esn}
                                                                    </div>
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>
                                                </Grid>
                                                <Grid xs={4} style={{ marginTop: 5 }}>
                                                    {
                                                        item.key !== "showLinkedMode" &&
                                                        getBadget(device[item.field] ? messages["common_active"] : messages["common_inactive"], device[item.field])
                                                    }
                                                    {
                                                        item.key === "showLinkedMode" &&
                                                        getBadget(device[item.field] ? messages["devices_import_camera_paired_mode"] : messages["devices_import_camera_gps"], device[item.field])
                                                    }
                                                </Grid>
                                            </Grid>
                                        )
                                    })
                                }
                            </div>
                        )
                    })
                }

                {
                    //---------------------------------
                }
                {
                    features.showAsset &&
                    <Grid container>
                        <Grid xs={4} className="pb-2">
                            <div className="d-flex">
                                <div>
                                    <Checkbox
                                        className="itemCheck mb-0"
                                        type="checkbox"
                                        id={"asset"}
                                        value={
                                            selectedItems.filter(x => x.deviceCategory && x.deviceCategory === "Asset").length === features.assetDevices.length
                                        }
                                        onChange={() => {
                                            let feat = features;
                                            let dvcs = feat.assetDevices;
                                            let dvcsSelected = selectedItems;

                                            if (dvcs.filter(x => x.deviceCategory && x.deviceCategory === "Asset").length === dvcs.length) {
                                                dvcs.map((item, key) => {
                                                    let indexSelected = dvcsSelected.findIndex(x => x.esn === item.esn);
                                                    item.deviceCategory = "Fleet";
                                                    dvcsSelected[indexSelected].deviceCategory = "Fleet";

                                                })
                                            } else {
                                                dvcs.map((item, key) => {
                                                    let indexSelected = dvcsSelected.findIndex(x => x.esn === item.esn);
                                                    item.deviceCategory = "Asset";
                                                    dvcsSelected[indexSelected].deviceCategory = "Asset";
                                                })
                                            }
                                            feat.assetDevices = dvcs;
                                            setFeatures({ ...feat });
                                            setSelectedItems([...dvcsSelected]);
                                        }}
                                    />
                                </div>
                                <div style={{ width: "100%", marginTop: 10 }}>
                                    <a
                                        style={{ textDecoration: "underline" }}
                                        onClick={() => {
                                            let feat = features;
                                            feat.openAssetDevices = !feat.openAssetDevices;
                                            setFeatures({ ...feat })
                                        }}>
                                        {messages["devices_import_device_category_asset"]}
                                    </a>
                                </div>
                            </div>
                        </Grid>
                        <Grid xs={4} style={{ marginTop: 5 }} className="pb-2">
                            <p className="text-muted mb-2">
                                {
                                    ` ${features.assetDevices.filter(x => x.deviceCategory === "Asset").length} ${messages["devices_import_of"]} ${features.assetDevices.length} ${messages["devices_import_devices_enabled"]}`
                                }
                            </p>
                        </Grid>
                    </Grid>

                }
                {
                    features.showAsset &&
                    features.openAssetDevices &&
                    features.assetDevices.map((dataItem, key) => {
                        let deviceIndex = selectedItems.findIndex(x => x.esn === dataItem.esn);
                        let device = selectedItems[deviceIndex];
                        let checked = device.deviceCategory === "Asset" ? true : false;
                        return (
                            <Grid container key={key}>
                                <Grid xs={4} style={{ marginLeft: "30px" }}>
                                    <div className="d-flex">
                                        <div >
                                            <Checkbox
                                                className="itemCheck mb-0"
                                                type="checkbox"
                                                id={"assetDevices_" + key}
                                                value={checked}
                                                label={dataItem.esn}
                                                onChange={(event) => {
                                                    let dvcs = selectedItems;
                                                    device.deviceCategory = !checked ? "Asset" : "Fleet";
                                                    dvcs[deviceIndex] = device;
                                                    setSelectedItems([...dvcs]);
                                                    setFeatures({ ...features })
                                                }}
                                            />
                                        </div>
                                    </div>
                                </Grid>
                                <Grid xs={4} style={{ marginTop: 5 }}>
                                    {
                                        getBadget(device.deviceCategory === "Asset" ? messages["common_active"] : messages["common_inactive"], device.deviceCategory === "Asset")
                                    }
                                </Grid>
                            </Grid>
                        )
                    })
                }
                {
                    //---------------------------------
                }
                {
                    features.showFleet &&
                    <Grid container>
                        <Grid xs={4} className="pb-2">
                            <div className="d-flex">
                                <div>
                                    <Checkbox
                                        className="itemCheck mb-0"
                                        type="checkbox"
                                        id={"fleet"}
                                        value={
                                            selectedItems.filter(x => x.deviceCategory && x.deviceCategory === "Fleet").length === features.fleetDevices.length
                                        }
                                        onChange={() => {
                                            let feat = features;
                                            let dvcs = feat.fleetDevices;
                                            let dvcsSelected = selectedItems;

                                            if (dvcs.filter(x => x.deviceCategory && x.deviceCategory === "Fleet").length === dvcs.length) {
                                                dvcs.map((item, key) => {
                                                    let indexSelected = dvcsSelected.findIndex(x => x.esn === item.esn);
                                                    item.deviceCategory = "Asset";
                                                    dvcsSelected[indexSelected].deviceCategory = "Asset";
                                                })
                                            } else {
                                                dvcs.map((item, key) => {
                                                    let indexSelected = dvcsSelected.findIndex(x => x.esn === item.esn);
                                                    item.deviceCategory = "Fleet";
                                                    dvcsSelected[indexSelected].deviceCategory = "Fleet";
                                                })
                                            }

                                            feat.fleetDevices = dvcs;
                                            setFeatures({ ...feat })
                                            setSelectedItems([...dvcsSelected])
                                        }}
                                    />
                                </div>
                                <div style={{ width: "100%", marginTop: 10 }}>
                                    <a
                                        style={{ textDecoration: "underline" }}
                                        onClick={() => {
                                            let feat = features;
                                            feat.openFleetDevices = !feat.openFleetDevices;
                                            setFeatures({ ...feat })
                                        }}>
                                        {messages["devices_import_device_category_fleet"]}
                                    </a>
                                </div>
                            </div>
                        </Grid>
                        <Grid xs={4} className="pb-2">
                            <p className="text-muted mb-2">
                                {
                                    ` ${features.fleetDevices.filter(x => x.deviceCategory === "Fleet").length} ${messages["devices_import_of"]} ${features.fleetDevices.length} ${messages["devices_import_devices_enabled"]}`
                                }
                            </p>
                        </Grid>
                    </Grid>

                }
                {
                    features.showFleet &&
                    features.openFleetDevices &&
                    features.fleetDevices.map((dataItem, key) => {
                        let deviceIndex = selectedItems.findIndex(x => x.esn === dataItem.esn);
                        let device = selectedItems[deviceIndex];
                        let checked = device.deviceCategory === "Fleet" ? true : false;
                        return (
                            <Grid container key={key}>
                                <Grid xs={4} style={{ marginLeft: "30px" }}>
                                    <div className="d-flex">
                                        <div >
                                            <Checkbox
                                                className="itemCheck mb-0"
                                                type="checkbox"
                                                id={"fleetDevices_" + key}
                                                value={checked}
                                                label={dataItem.esn}
                                                onChange={(event) => {
                                                    let dvcs = selectedItems;
                                                    device.deviceCategory = !checked ? "Fleet" : "Asset";
                                                    dvcs[deviceIndex] = device;
                                                    setSelectedItems([...dvcs]);
                                                    setFeatures({ ...features })
                                                }}
                                            />
                                        </div>
                                    </div>
                                </Grid>
                                <Grid sx={4}>
                                    {
                                        getBadget(device.deviceCategory === "Fleet" ? messages["common_active"] : messages["common_inactive"], device.deviceCategory === "Fleet")
                                    }
                                </Grid>
                            </Grid>
                        )
                    })
                }
            </Grid>
        )
    }

    // final step 5 isCSV -  
    const renderSummary = () => {
        return (
            <Grid style={{ marginBottom: 35 }}>
                <Grid style={{ marginBottom: 10 }}>
                    <div className="text-left mt-2 fs-20">
                        <h2>
                            {messages['devices_import_summary_title']}:
                            <strong className="ml-1">
                                {
                                    selectedItems.length
                                }
                            </strong>
                        </h2>
                    </div>
                </Grid>
                {selectedItems.length > 0 ? selectedItems.map((item, index) => {
                    return (
                        <CustomCard
                            key={index}
                            hideButton
                        >
                            <div style={{ display: 'grid' }}>
                                {
                                    (manufacturer?.name?.toUpperCase() !== "Vidfleet".toUpperCase() && manufacturer?.name?.toUpperCase() !== "Zonar".toUpperCase()) &&
                                    <div>
                                        <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['devices_import_imei']}</label><span>{item?.imei}</span>
                                    </div>
                                }
                                {
                                    (manufacturer?.name?.toUpperCase() !== "Queclink".toUpperCase() || manufacturer?.name?.toUpperCase() !== "TopFly".toUpperCase() || manufacturer?.name?.toUpperCase() !== "Pacific Track".toUpperCase() || manufacturer.name.toUpperCase() !== "Digital Matter".toUpperCase() || manufacturer.name.toUpperCase() !== "M2MD".toUpperCase()) &&
                                    <div>
                                        <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['devices_import_serial']}</label><span>{item?.esn}</span>
                                    </div>
                                }
                                {
                                    item?.iccid &&
                                    <div>
                                        <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['devices_import_iccid']}</label><span>{item?.iccid}</span>
                                    </div>
                                }
                                {
                                    item?.msisdn &&
                                    <div>
                                        <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['devices_import_msisdn']}</label><span>{item?.msisdn}</span>
                                    </div>
                                }
                                {
                                    manufacturer?.name?.toUpperCase() !== "zonar".toUpperCase() && manufacturer?.name?.toUpperCase() !== "lightmetrics".toUpperCase() &&
                                    <div>
                                        <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['devices_import_device_model']}</label><span>{item?.deviceModel?.name}</span>
                                    </div>
                                }
                            </div>
                        </CustomCard>
                    )
                }) : <div style={{ display: 'flex', justifyContent: 'center', marginTop: 25 }} ><span style={{ opacity: 0.6 }} >{messages['common_no_devices_added']}</span></div>}
            </Grid>
        )
    }

    const summaryCSVGetColumns = () => {
        let columns = []
        if (manufacturer.name.toUpperCase() !== "Pacific Track".toUpperCase()) {
            columns.push(
                {
                    key: "serial",
                    title: manufacturer.name.toUpperCase() === "CerebrumX".toUpperCase() ? messages['devices_import_vin'] : (manufacturer.name.toUpperCase() === "Pacific Track".toUpperCase() || manufacturer.name.toUpperCase() === "Digital Matter".toUpperCase() || manufacturer.name.toUpperCase() === "LightMetrics".toUpperCase() || manufacturer.name.toUpperCase() === "M2MD".toUpperCase()) ? messages['devices_import_imei'] : manufacturer.name.toUpperCase() === "SmartWitness".toUpperCase() ? messages['devices_import_serial_drid'] : messages['devices_import_serial'],
                    width: 130,
                    show: true,
                    sort: false,
                    locked: false,
                    resize: false,
                    render: (item) => {
                        return (
                            <span className={[1, 2].includes(item.Error) ? 'fg-danger' : ''} >{item?.esn}</span>
                        )
                    }
                }
            )
        }

        columns.push(
            {
                key: "label",
                title: messages['devices_import_label'],
                width: 150,
                show: true,
                sort: false,
                locked: false,
                resize: false,
                render: (item) => {
                    return (
                        <Input
                            type="text"
                            placeholder={messages["devices_import_label"]}
                            internal={true}
                            value={item.label}
                            maxLength={100}
                            onChange={(value) => {
                                let devs = devices;
                                let devIndex = devs.findIndex(x => x.esn === item.esn);
                                devs[devIndex].label = value;
                                setDevices([...devs])
                            }}
                        />
                    )
                }
            }
        )

        if (manufacturer.name.toUpperCase() === "CerebrumX".toUpperCase()) {
            columns.push(
                {
                    key: "package_name",
                    title: messages['devices_import_package_name'],
                    width: 150,
                    show: true,
                    sort: false,
                    locked: false,
                    resize: false,
                    render: (item) => {
                        return (
                            <span>{`${item?.packageName}`}</span>
                        )
                    }
                },
            );
        }

        if (simProviderAccount &&
            manufacturer.name.toUpperCase() !== "Global Star".toUpperCase() &&
            manufacturer.name.toUpperCase() !== "Zonar".toUpperCase() &&
            manufacturer.name.toUpperCase() !== "Digital Matter".toUpperCase() &&
            manufacturer.name.toUpperCase() !== "LightMetrics".toUpperCase()) {
            columns.push(
                {
                    key: "sim",
                    title: messages['devices_import_sim'],
                    width: 220,
                    show: true,
                    sort: false,
                    locked: false,
                    resize: false,
                    render: (item) => {
                        return (
                            <Input
                                type="text"
                                placeholder={messages["devices_import_sim"]}
                                internal={true}
                                value={item.iccid}
                                maxLength={20}
                                minLength={19}
                                onChange={(value) => {
                                    let devs = devices;
                                    let devIndex = devs.findIndex(x => x.esn === item.esn)
                                    devs[devIndex].iccid = value;

                                    setDevices([...devs])
                                }}
                                required={!(manufacturer.name.toUpperCase() === "VidFleet".toUpperCase())}
                                requiredMessage={messages["common_field_required"]}
                                minLengthMessage={messages["devices_import_valid_iccid_minlength"]}
                            />
                        )
                    }
                }
            );
            if (manufacturer.name.toUpperCase() !== "M2MD".toUpperCase())
                columns.push(
                    {
                        key: "phone",
                        title: messages['devices_import_phone'],
                        width: 200,
                        show: true,
                        sort: false,
                        locked: false,
                        resize: false,
                        render: (item) => {
                            return (
                                <Input
                                    type="text"
                                    placeholder={messages["devices_import_phone"]}
                                    internal={true}
                                    value={item.msisdn}
                                    maxLength={15}
                                    minLength={10}
                                    regex={"^[0-9]*$"}
                                    onChange={(value) => {
                                        let devs = devices;
                                        let devIndex = devs.findIndex(x => x.esn === item.esn)
                                        devs[devIndex].msisdn = value;

                                        setDevices([...devs])
                                    }}
                                    required={!(manufacturer.name.toUpperCase() === "VidFleet".toUpperCase())}
                                    requiredMessage={messages["common_field_required"]}
                                    minLengthMessage={messages["devices_import_valid_msisdn_minlength"]}
                                />
                            )
                        }
                    }
                );
        }

        if (manufacturer.name.toUpperCase() === "Calamp".toUpperCase() || manufacturer.name.toUpperCase() === "Geometris".toUpperCase()) {
            columns.push(
                {
                    key: "part_number",
                    title: messages['devices_import_part_number'],
                    width: 150,
                    show: true,
                    sort: false,
                    locked: false,
                    resize: false,
                    render: (item) => {
                        return (
                            <span className={[1, 2].includes(item.Error) ? 'fg-danger' : ''} >{item.Status ? item.Status === "PART_NUMBER_NOTFOUND" ? `${item?.partNumber} - PART_NUMBER_NOTFOUND` : item?.partNumber : item?.partNumber}</span>
                        )
                    }
                },
            );
        }

        if (manufacturer.name.toUpperCase() === "VidFleet".toUpperCase())
            columns.push(
                {
                    key: "sim_provider_account",
                    title: messages['devices_import_sim_provider_account'],
                    width: 150,
                    show: true,
                    sort: false,
                    locked: false,
                    resize: false,
                    render: (item) => {
                        return (
                            <span>{`${item?.simProviderAccount?.name}-${item?.simProviderAccount?.simProvider?.name}`}</span>
                        )
                    }
                },
            );

        columns.push(
            {
                key: "device_message",
                title: messages['devices_import_device_message'],
                width: 150,
                show: true,
                sort: false,
                locked: false,
                resize: false,
                render: (item) => {
                    return (
                        <span>
                            {
                                !item.ErrorSIM && item.Error &&
                                <span className={[1, 2].includes(item.Error) ? 'fg-danger' : item.Error === 3 ? '' : 'fg-success'}>
                                    {messages[item.Message] ? messages[item.Message] : item.Message}
                                </span>
                            }
                            {
                                item.ErrorSIM &&
                                <span className={item.ErrorSIM === 2 ? 'fg-danger' : item.ErrorSIM === 3 ? '' : 'fg-success'}>
                                    {messages[item.MessageSIM] ? messages[item.MessageSIM] : item.MessageSIM}
                                </span>
                            }
                        </span>
                    )
                }
            },
        );

        return columns;
    }

    const getColumnsManual = () => {
        let columns = [];

        let serialTitle = messages['devices_import_serial']

        if (manufacturer.name.toUpperCase() === "Global Star".toUpperCase() ||
            manufacturer.name.toUpperCase() === "Geometris".toUpperCase() ||
            manufacturer.name.toUpperCase() === "Positioning Universal".toUpperCase() ||
            manufacturer.name.toUpperCase() === "Queclink".toUpperCase() ||
            manufacturer.name.toUpperCase() === "TopFly".toUpperCase()) {
            serialTitle = messages['devices_import_serial_imei']
        }

        if (manufacturer.name.toUpperCase() === "SmartWitness".toUpperCase()) {
            serialTitle = messages['devices_import_serial_drid']
        }

        if (manufacturer.name.toUpperCase() === "CerebrumX".toUpperCase()) {
            serialTitle = messages['devices_import_vin']
        }

        if (manufacturer.name.toUpperCase() !== "Pacific Track".toUpperCase() && manufacturer.name.toUpperCase() !== "Digital Matter".toUpperCase() && manufacturer.name.toUpperCase() !== "LightMetrics".toUpperCase() && manufacturer.name.toUpperCase() !== "M2MD".toUpperCase())
            columns.push(
                {
                    key: "esn",
                    title: serialTitle,
                    width: 150,
                    show: true,
                    sort: false,
                    locked: false,
                    resize: false,
                    render: (item) => {
                        return (
                            <span className={[1, 2].includes(item.Error) ? 'fg-danger' : ''} >{item?.esn}</span>
                        )
                    }
                }
            );

        if (manufacturer.name.toUpperCase() !== "Global Star".toUpperCase() &&
            manufacturer.name.toUpperCase() !== "Geometris".toUpperCase() &&
            manufacturer.name.toUpperCase() !== "Positioning Universal".toUpperCase() &&
            manufacturer.name.toUpperCase() !== "SmartWitness".toUpperCase() &&
            manufacturer.name.toUpperCase() !== "VidFleet".toUpperCase() &&
            manufacturer.name.toUpperCase() !== "Queclink".toUpperCase() &&
            manufacturer.name.toUpperCase() !== "TopFly".toUpperCase() &&
            manufacturer.name.toUpperCase() !== "CerebrumX".toUpperCase() &&
            manufacturer.name.toUpperCase() !== "Zonar".toUpperCase()) {
            columns.push(
                {
                    key: "imei",
                    title: messages['devices_import_imei'],
                    width: 150,
                    show: true,
                    sort: false,
                    locked: false,
                    resize: false,
                    render: (item) => {
                        return (
                            <span className={[1, 2].includes(item.Error) ? 'fg-danger' : ''}>{item?.imei}</span>
                        )
                    }
                }
            );
        }

        //if (manufacturer.name.toUpperCase() !== "SmartWitness".toUpperCase()) {
        columns.push(
            {
                key: "label",
                title: messages['devices_import_label'],
                width: 150,
                show: true,
                sort: false,
                locked: false,
                resize: false,
                render: (item) => {
                    return (
                        <Input
                            type="text"
                            placeholder={messages["devices_import_label"]}
                            internal={true}
                            value={item.label}
                            maxLength={16}
                            onChange={(value) => {
                                let devs = selectedItems;
                                let devIndex = devs.findIndex(x => x.esn === item.esn);
                                devs[devIndex].label = value;
                                setSelectedItems([...devs])
                            }}
                        />
                    )
                }
            }
        )

        if (manufacturer.name.toUpperCase() !== "Global Star".toUpperCase() &&
            manufacturer.name.toUpperCase() !== "CerebrumX".toUpperCase() &&
            manufacturer.name.toUpperCase() !== "Zonar".toUpperCase() &&
            manufacturer.name.toUpperCase() !== "Digital Matter".toUpperCase() &&
            manufacturer.name.toUpperCase() !== "LightMetrics".toUpperCase()) {

            columns.push(
                {
                    key: "sim",
                    title: messages['devices_import_sim'],
                    width: 220,
                    show: true,
                    sort: false,
                    locked: false,
                    resize: false,
                    render: (item) => {
                        return (
                            <Input
                                type="text"
                                placeholder={messages["devices_import_sim"]}
                                internal={true}
                                value={item.iccid}
                                maxLength={20}
                                minLength={19}
                                regex={"^[a-zA-Z0-9_.-]*$"}
                                onChange={(value) => {
                                    let devs = selectedItems;
                                    let devIndex = devs.findIndex(x => x.esn === item.esn)
                                    devs[devIndex].iccid = value;

                                    setSelectedItems([...devs])
                                }}
                                required={!(manufacturer.name.toUpperCase() === "VidFleet".toUpperCase())}
                                requiredMessage={messages["common_field_required"]}
                                minLengthMessage={messages["devices_import_valid_iccid_minlength"]}
                            />
                        )
                    }
                }
            );

            if (manufacturer.name.toUpperCase() !== "VidFleet".toUpperCase() && manufacturer.name.toUpperCase() !== "M2MD".toUpperCase())
                columns.push(
                    {
                        key: "phone",
                        title: messages['devices_import_phone'],
                        width: 200,
                        show: true,
                        sort: false,
                        locked: false,
                        resize: false,
                        render: (item) => {
                            return (
                                <Input
                                    type="text"
                                    placeholder={messages["devices_import_phone"]}
                                    internal={true}
                                    value={item.msisdn}
                                    maxLength={15}
                                    minLength={10}
                                    regex={"^[0-9]*$"}
                                    onChange={(value) => {
                                        let devs = selectedItems;
                                        let devIndex = devs.findIndex(x => x.esn === item.esn)
                                        devs[devIndex].msisdn = value;

                                        setSelectedItems([...devs])
                                    }}
                                    required={!(manufacturer.name.toUpperCase() === "VidFleet".toUpperCase() || manufacturer.name.toUpperCase() === "SmartWitness".toUpperCase())}
                                    requiredMessage={messages["common_field_required"]}
                                    minLengthMessage={messages["devices_import_valid_msisdn_minlength"]}
                                />
                            )
                        }
                    }
                );
        }

        if (manufacturer.name.toUpperCase() !== "Global Star".toUpperCase() &&
            manufacturer.name.toUpperCase() !== "CerebrumX".toUpperCase() &&
            manufacturer.name.toUpperCase() !== "LightMetrics".toUpperCase() &&
            manufacturer.name.toUpperCase() !== "Zonar".toUpperCase() &&
            manufacturer.name.toUpperCase() !== "M2MD".toUpperCase()) {
            columns.push(
                {
                    key: "sim_provider_account",
                    title: messages['devices_import_sim_provider_account'],
                    width: 250,
                    show: true,
                    sort: false,
                    locked: false,
                    resize: false,
                    render: (item) => {
                        return (
                            <span>{`${item?.simProviderAccount?.name}-${item?.simProviderAccount?.simProvider?.name}`}</span>
                        )
                    }
                },
            );
        }

        if (
            manufacturer.name.toUpperCase() === "Geometris".toUpperCase() ||
            manufacturer.name.toUpperCase() === "CalAmp".toUpperCase()
        ) {
            columns.push(
                {
                    key: "part_number",
                    title: messages['devices_import_part_number'],
                    width: 150,
                    show: true,
                    sort: false,
                    locked: false,
                    resize: false,
                    render: (item) => {
                        return (
                            <span className={[1, 2].includes(item.Error) ? 'fg-danger' : ''} >{item.Status ? item.Status === "PART_NUMBER_NOTFOUND" ? `${item?.partNumber} - PART_NUMBER_NOTFOUND` : item?.partNumber : item?.partNumber}</span>
                        )
                    }
                }
            );
        }

        if (manufacturer.name.toUpperCase() === "CerebrumX".toUpperCase()) {
            columns.push(
                {
                    key: "package_name",
                    title: messages['devices_import_package_name'],
                    width: 150,
                    show: true,
                    sort: false,
                    locked: false,
                    resize: false,
                    render: (item) => {
                        return (
                            <span>{`${item?.packageName}`}</span>
                        )
                    }
                },
            );
        }

        columns.push(
            {
                key: "device_message",
                title: messages['devices_import_device_message'],
                width: 150,
                show: true,
                sort: false,
                locked: false,
                resize: false,
                render: (item) => {
                    return (
                        <span>
                            {
                                !item.ErrorSIM && item.Error &&
                                <span className={item.Error !== 3 ? 'fg-danger' : item.Error === 3 ? '' : 'fg-success'}>
                                    {messages[item.Message] ? messages[item.Message] : item.Message}
                                </span>
                            }
                            {
                                item.ErrorSIM &&
                                <span className={item.ErrorSIM === 2 ? 'fg-danger' : item.ErrorSIM === 3 ? '' : 'fg-success'}>
                                    {messages[item.MessageSIM] ? messages[item.MessageSIM] : item.MessageSIM}
                                </span>
                            }
                        </span>
                    )
                }
            },
        );

        columns.push(
            {
                key: "delete",
                title: "",
                width: 50,
                show: true,
                sort: false,
                locked: false,
                resize: false,
                render: (item) => {
                    return (
                        <span>
                            <Tooltip title={messages["common_remove"]}>
                                <IconButton
                                    style={{ padding: 5 }}
                                    onClick={() => {
                                        let devices = []
                                        devices = selectedItems.filter(x => x.esn !== item.esn)
                                        setSelectedItems([...devices])
                                        setError([])
                                    }}
                                    size="large">
                                    <RemoveCircleIcon />
                                </IconButton>
                            </Tooltip>
                        </span>
                    );
                }
            },
        );

        return columns;
    }

    const markFeatures = (enable) => {
        let feat = features;

        let dvcs = selectedItems;

        /* 
        deviceCategory: enumDeviceCategory!
        
        */

        dvcs.map((device, key) => {
            if (feat.promilesDevices.find(x => x.esn === device.esn)) {
                device.promiles = enable;
            }
            if (feat.driverBehaviorDevices.find(x => x.esn === device.esn)) {
                device.driverBehavior = enable;
            }
            if (feat.cariqDevices.find(x => x.esn === device.esn)) {
                device.cariq = enable;
            }
            if (feat.carbDevices.find(x => x.esn === device.esn)) {
                device.carb = enable;
            }
            if (feat.promilesOdometerCalculatedDevices.find(x => x.esn === device.esn)) {
                device.promilesOdometerCalculated = enable;
            }
            if (feat.comDataDevices.find(x => x.esn === device.esn)) {
                device.comdata = enable;
            }
            if (feat.apuDevices.find(x => x.esn === device.esn)) {
                device.apu = enable;
            }
            if (feat.hybridDevices.find(x => x.esn === device.esn)) {
                device.hybrid = enable;
            }

            if (feat.vBusDevices.find(x => x.esn === device.esn)) {
                device.vbus = enable;
            }
            if (feat.jBusDevices.find(x => x.esn === device.esn)) {
                device.jbus = !enable;
            }
            if (feat.pressureProDevices.find(x => x.esn === device.esn)) {
                device.pressurePro = enable;
            }
            if (feat.batteryDevices.find(x => x.esn === device.esn)) {
                device.battery = enable;
            }
            if (feat.useEcuOdometerDevices.find(x => x.esn === device.esn)) {
                device.useEcuOdometer = enable;
            }
            if (feat.useEcuEngineHoursDevices.find(x => x.esn === device.esn)) {
                device.useEcuEngineHours = enable;
            }
            if (feat.useEcuSpeedDevices.find(x => x.esn === device.esn)) {
                device.useEcuSpeed = enable;
            }
            if (feat.useEcuVinDevices.find(x => x.esn === device.esn)) {
                device.useEcuVin = enable;
            }
            if (feat.showDevices.find(x => x.esn === device.esn)) {
                device.show = enable;
            }
            if (feat.linkedModeDevices.find(x => x.esn === device.esn)) {
                device.linkedMode = enable;
            }
            if (feat.analyticsDevices.find(x => x.esn === device.esn)) {
                device.analytics = enable;
            }

            device.deviceCategory = enable ? "Fleet" : "Asset";
        });

        setSelectedItems([...dvcs]);
        setFeatures({ ...feat })

    }

    const loadDevicesFeatures = () => {

        let feat = features;

        let showPromiles = false,
            promilesDevices = [],
            showDriverBehavior = false,
            driverBehaviorDevices = [],
            showVBus = false,
            vBusDevices = [],
            showJBus = false,
            jBusDevices = [],

            showAsset = true,
            assetDevices = [],
            showFleet = true,
            fleetDevices = [],
            showComData = false,
            comDataDevices = [],
            showPressurePro = false,
            pressureProDevices = [],
            showBattery = false,
            batteryDevices = [],

            showApu = true,
            apuDevices = [],
            showHybrid = true,
            hybridDevices = [],
            showPromilesOdometerCalculated = false,
            promilesOdometerCalculatedDevices = [],
            showUseEcuOdometer = false,
            useEcuOdometerDevices = [],
            showUseEcuEngineHours = false,
            useEcuEngineHoursDevices = [],
            showUseEcuSpeed = false,
            useEcuSpeedDevices = [],
            showUseEcuVin = false,
            useEcuVinDevices = [],
            show = true,
            showDevices = [],
            showAnalytics = false,
            analyticsDevices = [],
            showLinkedMode = false,
            linkedModeDevices = [],
            showCariq = false,
            cariqDevices = [],
            showCarb = false,
            carbDevices = []

        let devicesFiltered = selectedItems
        devicesFiltered.map(device => {

            if (isCSV && manufacturer.name.toUpperCase() !== "CALAMP" && manufacturer.name.toUpperCase() !== "GEOMETRIS") {
                device.deviceModel = deviceModel;
            }

            if (account?.hasPromiles && typeof device.deviceModel?.promiles !== 'undefined' && device.deviceModel?.promiles !== null && device.deviceModel?.promiles) {
                showPromiles = true;
                showPromilesOdometerCalculated = true;
                device.promiles = false;
                device.promilesOdometerCalculated = false;
                promilesDevices.push(device);
                promilesOdometerCalculatedDevices.push(device);
            }


            if (typeof device.deviceModel?.driverBehavior !== 'undefined' && device.deviceModel?.driverBehavior !== null && device.deviceModel?.driverBehavior) {
                showDriverBehavior = true;
                device.driverBehavior = device.deviceModel?.driverBehavior;
                driverBehaviorDevices.push(device);
            }

            if (typeof device.deviceModel?.cariq !== 'undefined' && device.deviceModel?.cariq !== null && device.deviceModel?.cariq) {
                showCariq = true;
                device.cariq = false;
                cariqDevices.push(device);
            }

            if (typeof device.deviceModel?.carbEnable !== 'undefined' && device.deviceModel?.carbEnable !== null && device.deviceModel?.carbEnable) {
                showCarb = true;
                device.carb = false;
                carbDevices.push(device);
            }

            if ((typeof device.deviceModel?.vbus !== 'undefined' && device.deviceModel?.vbus !== null && device.deviceModel?.vbus) || manufacturer.name.toUpperCase() === "Zonar".toUpperCase()) {
                showVBus = true;
                device.vbus = false;
                if (manufacturer.name.toUpperCase() === "CalAmp".toUpperCase()) {
                    if (device.deviceModel.name.includes("3030") || device.deviceModel.name.includes("3035")) {
                        device.vbus = true;
                    }
                }
                if (manufacturer.name.toUpperCase() === "Geometris".toUpperCase()) {
                    const modelsToCheck = ["88", "87"];
                    device.vbus = modelsToCheck.some(model => device.deviceModel.name.includes(model));
                }

                if (manufacturer.name.toUpperCase() === "CerebrumX".toUpperCase()) {
                    device.vbus = true;
                    device.jbus = false;

                    // for cerebrumx hide this options as they are always enabled
                    showVBus = false;
                    showJBus = false;
                }

                if (manufacturer.name.toUpperCase() === "Zonar".toUpperCase()) {
                    device.vbus = false;
                }

                vBusDevices.push(device);
            }

            if ((typeof device.deviceModel?.jbus !== 'undefined' && device.deviceModel?.jbus !== null && device.deviceModel?.jbus) || manufacturer.name.toUpperCase() === "Zonar".toUpperCase()) {
                showJBus = true;
                device.jbus = false;
                if (manufacturer.name.toUpperCase() === "Zonar".toUpperCase()) {
                    device.jbus = true;
                }
                jBusDevices.push(device);
            }

            if (typeof device.deviceModel?.battery !== 'undefined' && device.deviceModel?.battery !== null && device.deviceModel?.battery) {
                showBattery = true;
                device.battery = device.deviceModel?.battery;
                batteryDevices.push(device);
            }

            if (typeof device.deviceModel?.analytics !== 'undefined' && device.deviceModel?.analytics !== null && device.deviceModel?.analytics) {
                showAnalytics = true;
                device.analytics = device.deviceModel?.analytics;
                analyticsDevices.push(device);
            }

            if ((typeof device.deviceModel?.hoursEnable !== 'undefined' && device.deviceModel?.hoursEnable !== null && device.deviceModel?.hoursEnable) || manufacturer.name.toUpperCase() === "Zonar".toUpperCase()) {
                showUseEcuEngineHours = true;
                device.useEcuEngineHours = false;
                if (manufacturer.name.toUpperCase() === "CalAmp".toUpperCase()) {
                    if (device.deviceModel.name.includes("3030") || device.deviceModel.name.includes("3035")) {
                        device.useEcuEngineHours = true;
                    }
                }

                if (manufacturer.name.toUpperCase() === "Geometris".toUpperCase()) {
                    if (geometrisModelsAvailables.some(x => x === device.esn.substring(0, 2))) {
                        device.useEcuEngineHours = true;
                    }
                }
                if (manufacturer.name.toUpperCase() === "CerebrumX".toUpperCase()) {
                    device.useEcuEngineHours = true;

                    // for cerebrumx hide this options as they are always enabled
                    showUseEcuEngineHours = false;
                }

                if (manufacturer.name.toUpperCase() === "Zonar".toUpperCase()) {
                    device.useEcuEngineHours = true;
                }

                useEcuEngineHoursDevices.push(device);
            }

            if ((device.deviceModel?.odometerEnable && (device.deviceModel?.jbus || device.deviceModel?.vbus)) || manufacturer.name.toUpperCase() === "Zonar".toUpperCase()) {
                showUseEcuOdometer = true;
                showUseEcuSpeed = true;
                showUseEcuVin = true;
                device.useEcuOdometer = false;
                device.useEcuSpeed = false;
                device.useEcuVin = false;

                if (manufacturer.name.toUpperCase() === "CalAmp".toUpperCase()) {
                    if (device.deviceModel.name.includes("3030") || device.deviceModel.name.includes("3035")) {
                        device.useEcuOdometer = true;
                        device.useEcuSpeed = true;
                        device.useEcuVin = true;
                    }
                }

                if (manufacturer.name.toUpperCase() === "Geometris".toUpperCase()) {
                    if (geometrisModelsAvailables.some(x => x === device.esn.substring(0, 2))) {
                        device.useEcuOdometer = true;
                        device.useEcuSpeed = true;
                        device.useEcuVin = true;
                    }
                }

                if (manufacturer.name.toUpperCase() === "CerebrumX".toUpperCase()) {
                    device.useEcuOdometer = true;
                    device.useEcuSpeed = true;
                    device.useEcuVin = true;

                    // for cerebrumx hide this options as they are always enabled
                    showUseEcuOdometer = false;
                    showUseEcuSpeed = false;
                    showUseEcuVin = false;
                }

                if (manufacturer.name.toUpperCase() === "Zonar".toUpperCase()) {
                    device.useEcuOdometer = true;
                    device.useEcuSpeed = false;
                    device.useEcuVin = false;
                }


                useEcuOdometerDevices.push(device);
                useEcuSpeedDevices.push(device);
                useEcuVinDevices.push(device);
            }


            if (manufacturer.name.toUpperCase() === "SmartWitness".toUpperCase()) {
                showLinkedMode = true;
                device.linkedMode = true;
                device.useEcuSpeed = false;
                device.useEcuVin = false;
                device.apu = false;
                device.hybrid = false;

                linkedModeDevices.push(device);
                vBusDevices.push(device);
            }
            if (manufacturer.name.toUpperCase() === "VidFleet".toUpperCase() || manufacturer.name.toUpperCase() === "Lightmetrics".toUpperCase()) {
                showLinkedMode = true;
                device.linkedMode = true;
                device.useEcuSpeed = false;
                device.useEcuVin = false;
                device.apu = false;
                device.hybrid = false;

                showUseEcuSpeed = true;
                showUseEcuVin = true;

                showVBus = true
                device.vbus = false

                linkedModeDevices.push(device);
                vBusDevices.push(device);
                useEcuSpeedDevices.push(device);
                useEcuVinDevices.push(device);
            }


            //asset
            if (manufacturer.name.toUpperCase() === "CalAmp".toUpperCase()) {
                if (device.deviceModel.name.includes("2830") || device.deviceModel.name.includes("730")) {
                    device.driverBehavior = false;
                    device.deviceCategory = "Asset";
                } else {
                    device.deviceCategory = "Fleet";
                }
            } else if (manufacturer.name.toUpperCase() === "Queclink".toUpperCase()) {
                if (device.deviceModel.name.includes("500MG")) {
                    device.deviceCategory = "Asset";
                } else {
                    device.deviceCategory = "Fleet";
                }
            } else if (manufacturer.name.toUpperCase() === "M2MD".toUpperCase()) {
                device.deviceCategory = "Asset";
            } else {
                device.deviceCategory = "Fleet";
            }

            //for asset and fleet categories
            device.show = true;
            assetDevices.push(device);
            fleetDevices.push(device);
            showDevices.push(device);
            hybridDevices.push(device);
            apuDevices.push(device);


        });


        feat.showPromiles = showPromiles;
        feat.promilesDevices = promilesDevices;
        feat.showPromilesOdometerCalculated = showPromilesOdometerCalculated;
        feat.promilesOdometerCalculatedDevices = promilesOdometerCalculatedDevices;

        feat.showDriverBehavior = showDriverBehavior;
        feat.driverBehaviorDevices = driverBehaviorDevices;
        feat.showVBus = showVBus;
        feat.vBusDevices = vBusDevices;
        feat.showJBus = showJBus;
        feat.jBusDevices = jBusDevices;

        feat.showAsset = showAsset;
        feat.assetDevices = assetDevices;
        feat.showFleet = showFleet;
        feat.fleetDevices = fleetDevices;
        feat.showComData = showComData;
        feat.comDataDevices = comDataDevices;
        feat.showPressurePro = showPressurePro;
        feat.pressureProDevices = pressureProDevices;
        feat.showBattery = showBattery;
        feat.batteryDevices = batteryDevices;

        feat.showUseEcuEngineHours = showUseEcuEngineHours;
        feat.useEcuEngineHoursDevices = useEcuEngineHoursDevices;

        feat.showUseEcuOdometer = showUseEcuOdometer;
        feat.useEcuOdometerDevices = useEcuOdometerDevices;
        feat.showUseEcuSpeed = showUseEcuSpeed;
        feat.useEcuSpeedDevices = useEcuSpeedDevices;
        feat.showUseEcuVin = showUseEcuVin;
        feat.useEcuVinDevices = useEcuVinDevices;

        feat.showApu = showApu;
        feat.apuDevices = apuDevices;
        feat.showHybrid = showHybrid;
        feat.hybridDevices = hybridDevices;
        feat.show = show;
        feat.showDevices = showDevices;
        feat.showAnalytics = showAnalytics;
        feat.analyticsDevices = analyticsDevices;
        feat.showLinkedMode = showLinkedMode;
        feat.linkedModeDevices = linkedModeDevices;

        feat.showCariq = showCariq
        feat.cariqDevices = cariqDevices

        feat.showCarb = showCarb
        feat.carbDevices = carbDevices

        setFeatures({ ...feat })


    }

    const focusNextControl = (event) => {
        const form = event.target.form;
        const index = Array.prototype.indexOf.call(form, event.target);
        form.elements[index + 1].focus();
        event.preventDefault();
    }

    useEffect(() => {

        if (fileResponse) {
            dispatch(clearRedux("IMPORT_DEVICES", { fileResponse: null }))

            const { Error, ErrorMessage } = fileResponse
            if (!Error && fileResponse?.Devices?.length) {
                let devices = fileResponse.Devices
                tableRefCSVSymmary?.current?.setSelectedItems([...devices]);
                setSelectedItems([...devices]);
                setDevices([...devices])
            } else if (Error === 1) {
                setError(Error);
                setErrorMessage(ErrorMessage);
            }
        }

        if (deviceModelSelected) {
            dispatch(clearRedux("IMPORT_DEVICES", { deviceModel: null }));
            if (!deviceModelSelected.error) {
                setDeviceModel(deviceModelSelected)
            }
        }

        if (devicesPhones) {
            dispatch(clearRedux("IMPORT_DEVICES", { devicesPhones: null }));
        }

        if (importResult) {
            dispatch(clearRedux("IMPORT_DEVICES", { importResult: null }));
            if (!importResult?.data?.error) {
                let transactionId = importResult.data.DevicesResult.transactionId;
                let message = messages["devices_import_transaction_request_message"]
                NotificationManager.success(message, messages['devices_import_title'], 10000, () => {
                    copyToClipboard(transactionId, messages['common_copied']);
                    navigate(`/app/transactions/list/${transactionId}`);

                }, null, '', null);

                closeModal();

            } else {
                let error = true;
                let message = messages["devices_import_save_error"]
                if (importResult?.data?.error?.error) {
                    if (messages[importResult.data.error.error])
                        message = messages[importResult.data.error.error]
                    else
                        message = importResult.data.error.error.replace("Bad request ->", "").replace("GraphQL error: ", "")
                }


                //NotificationManager.error(message, messages['devices_import_title'], 6000, null, null, '', null);
            }
        }

        if (calampDevices) {
            dispatch(clearRedux("IMPORT_DEVICES", { calampDevices: null }));
            if (!calampDevices.error) {
                setSelectedItems([...selectedItems, ...calampDevices])
                setDeviceSearchCriteria("");
            }
        }

        if (geometrisDevices) {
            dispatch(clearRedux("IMPORT_DEVICES", { geometrisDevices: null }));
            if (!geometrisDevices.error) {
                setSelectedItems([...selectedItems, ...geometrisDevices])
                setDeviceSearchCriteria("");
            }
        }

    }, [fileResponse, deviceModelSelected, devicesPhones, importResult, calampDevices, geometrisDevices]);

    useEffect(() => {
        manufacturers && manufacturers.length === 0 && dispatch(searchEntityRequest({ key: "manufacturers" }));
        deviceModels && deviceModels.length === 0 && dispatch(searchEntityRequest({ key: "deviceModels" }));
        simProviderAccounts && simProviderAccounts.length === 0 && dispatch(searchEntityRequest({ key: "simProviderAccounts" }));
        timeZones && timeZones.length === 0 && dispatch(searchEntityRequest({ key: "timezones" }));
        dispatch(searchEntityRequest({ key: "tags" }));
        //(!integrations || integrations?.length === 0) && dispatch(searchEntityRequest({ key: "integrations" }));

    }, []);

    useEffect(() => {
        dispatch(addIntegrationGetIntegrationsRequest())
    }, [])

    return (
        <Modal
            open={openModal}
            title={`${messages['devices_import_title']} ${account ? `(${account.name})` : ""} ${manufacturer ? `(${manufacturer.name})` : ""}`}
            position="right"
            size="extra-large"
            handleClose={closeModal}
            loading={loading}
        >
            <ModalBody>
                <Grid container>
                    <Grid item className="" style={{ width: '100%' }}>
                        <ProgressBar
                            steps={5}
                            activeStep={step}
                        />
                    </Grid>
                    <Grid item style={{ padding: '0 10px', width: "100%", marginBottom: 15 }}>
                        {
                            step === 1 &&
                            renderInputSelection()
                        }
                        {
                            step === 2 && isCSV &&
                            renderInputFormCSV()
                        }
                        {
                            step === 2 && !isCSV &&
                            renderInputFormManual()
                        }
                        {
                            step === 3 && isCSV &&
                            renderSummaryCVS()
                        }
                        {
                            step === 3 && !isCSV &&
                            renderFeaturesSelecction()
                        }
                        {
                            step === 4 && isCSV &&
                            renderFeaturesSelecction()
                        }
                        {
                            step === 4 && !isCSV &&
                            renderSummary()
                        }
                        {
                            step == 5 && isCSV &&
                            renderSummary()
                        }
                    </Grid>
                </Grid>
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn-cancel"
                    onClick={() => closeModal()}
                >
                    {messages['common_cancel']}
                </Button>
                {step > 1 &&
                    <Button
                        className="btn-cancel"
                        onClick={() => {
                            let nextStep = step - 1
                            switch (nextStep) {
                                case 1:
                                    setSimProviderAccount(null);
                                    setCSV(null);
                                    setErrorMessage(null);
                                    setSelectedItems([]);
                                    setDevices([])
                                    manufacturer.name.toUpperCase() === "CEREBRUMX" && setDeviceModel(null);
                                    setDeviceSearchCriteria("");
                                    setDevice({ imei: null, esn: null, iccid: null, msisdn: null })
                                    break;
                                case 2:
                                    if (isCSV) {
                                        setDevices([])
                                        setCSV(null);
                                    }
                                    break;
                                case 3:
                                    if (isCSV) {
                                        setSelectedItems([])
                                    }
                                    break;

                                default:
                                    break;
                            }


                            setStep(nextStep)
                        }}
                    >
                        {messages['common_back']}
                    </Button>
                }
                <Button
                    disabled={
                        (step === 1 && (!account || !reference || !manufacturer || ((manufacturer?.name?.toUpperCase() === "CEREBRUMX" || manufacturer?.name?.toUpperCase() === "ZONAR") && !isIntegrationEnabled))) ||
                        (step === 2 && isCSV && (
                            (
                                !deviceModel &&
                                manufacturer.name.toUpperCase() !== "CALAMP" &&
                                manufacturer.name.toUpperCase() !== "VIDFLEET" &&
                                manufacturer.name.toUpperCase() !== "LIGHTMETRICS" &&
                                manufacturer.name.toUpperCase() !== "GEOMETRIS" &&
                                manufacturer?.name?.toUpperCase() !== "ZONAR"
                            )
                            ||
                            (
                                (
                                    manufacturer?.name?.toUpperCase() !== "CEREBRUMX" &&
                                    manufacturer?.name?.toUpperCase() !== "ZONAR") &&
                                !simProviderAccount)
                            ||
                            !CSV)
                        )
                        ||
                        (step === 3 && isCSV && (selectedItems && selectedItems.length === 0)) ||
                        (step === 5 && selectedItems && selectedItems.length > 300)
                    }
                    className="btn-dark-blue"
                    onClick={() => {
                        switch (step) {
                            case 1:
                                setStep(2);
                                break;
                            case 2:
                                if (isCSV) {
                                    setError(0);
                                    setErrorMessage("");
                                    formCSVInput?.current?.submit();
                                } else {

                                    if (selectedItems.length === 0) {
                                        NotificationManager.error(messages["devices_import_error_no_devices"], messages['devices_import_title'], 6000, null, null, '', null);
                                    } else if (selectedItems.filter(x => (x.Error)).length > 0) {
                                        NotificationManager.error(messages["devices_import_error_devices"], messages['devices_import_title'], 6000, null, null, '', null);
                                    } else if (manufacturer.name.toUpperCase() !== "VidFleet".toUpperCase() && manufacturer.name.toUpperCase() !== "SMARTWITNESS" && manufacturer.name.toUpperCase() !== "GLOBAL STAR" && manufacturer.name.toUpperCase() !== "CEREBRUMX" && manufacturer.name.toUpperCase() !== "ZONAR" && manufacturer.name.toUpperCase() !== "DIGITAL MATTER" && manufacturer?.name?.toUpperCase() !== "LightMetrics".toUpperCase() && manufacturer?.name?.toUpperCase() !== "M2MD".toUpperCase() && selectedItems.filter(x => (!x.msisdn || x.msisdn.length < 8)).length > 0) {
                                        NotificationManager.error(messages["devices_import_error_msisdn_missing"], messages['devices_import_title'], 6000, null, null, '', null);
                                    } else {
                                        //this.refs.formLoadForms.onValidSubmit(event)
                                        loadDevicesFeatures();
                                        setStep(3);
                                    }
                                }
                                break;
                            case 3:
                                if (isCSV) {
                                    let dvcs = selectedItems;
                                    let error = 0;
                                    let errorMessage = null;


                                    if (dvcs.length === 0) {
                                        error = 1;
                                        errorMessage = "devices_import_error_unselected_devices";
                                    } else if (dvcs.length > 300) {
                                        error = 1;
                                        errorMessage = "devices_import_error_limit_devices";
                                    } else if (manufacturer?.name?.toUpperCase() !== "VidFleet".toUpperCase() &&
                                        manufacturer.name.toUpperCase() !== "CEREBRUMX" &&
                                        manufacturer.name.toUpperCase() !== "ZONAR" &&
                                        manufacturer.name.toUpperCase() !== "DIGITAL MATTER" &&
                                        manufacturer?.name?.toUpperCase() !== "LightMetrics".toUpperCase() &&
                                        !simProviderAccount?.name?.toUpperCase().includes("LATAM") && //only for LATAM sim provider accounts
                                        dvcs.filter(x => (!x.iccid || x.iccid.length < 19 || (x.Error === 1 && x.Message === "devices_import_valid_iccid_minlength"))).length > 0) {
                                        let errorFound = false;
                                        dvcs.map((item, index) => {
                                            if ((!item.iccid || item.iccid.length < 19)) {
                                                item.Error = 1;
                                                item.Message = "devices_import_valid_iccid_minlength";
                                                errorFound = true;
                                            } else {
                                                item.Error = 0;
                                                item.Message = "";
                                            }
                                        })

                                        if (errorFound) {
                                            error = 1;
                                            errorMessage = "devices_import_valid_iccid_minlength_general";
                                        }

                                        setSelectedItems([...dvcs])

                                    } else if (manufacturer?.name?.toUpperCase() !== "VidFleet".toUpperCase() && manufacturer.name.toUpperCase() !== "CEREBRUMX" && manufacturer.name.toUpperCase() !== "ZONAR" && manufacturer.name.toUpperCase() !== "SMARTWITNESS" && manufacturer.name.toUpperCase() !== "DIGITAL MATTER" && manufacturer?.name?.toUpperCase() !== "LightMetrics".toUpperCase() && manufacturer?.name?.toUpperCase() !== "M2MD".toUpperCase() && dvcs.filter(x => (!x.msisdn || x.msisdn.length < 8 || (x.Error === 1 && x.Message === "devices_import_valid_msisdn_minlength"))).length > 0) {
                                        let errorFound = false;
                                        dvcs.map((item, index) => {
                                            if ((!item.msisdn || item.msisdn.length < 8)) {
                                                item.Error = 1;
                                                item.Message = "devices_import_valid_msisdn_minlength";
                                                errorFound = true;
                                            } else {
                                                item.Error = 0;
                                                item.Message = "";
                                            }
                                        })
                                        setSelectedItems([...dvcs])
                                        if (errorFound) {
                                            error = 1;
                                            errorMessage = "devices_import_error_msisdn_missing_general";
                                        }
                                    } else if (manufacturer?.name?.toUpperCase() !== "VidFleet".toUpperCase() && manufacturer.name.toUpperCase() !== "CEREBRUMX" && manufacturer.name.toUpperCase() !== "ZONAR" && manufacturer.name.toUpperCase() !== "DIGITAL MATTER" && manufacturer?.name?.toUpperCase() !== "LightMetrics".toUpperCase() && manufacturer.name.toUpperCase() !== "SMARTWITNESS" && manufacturer?.name?.toUpperCase() !== "M2MD".toUpperCase() && dvcs.filter(x => !(/^\d+$/.test(x.msisdn))).length > 0) {
                                        let errorFound = false;
                                        dvcs.map((item, index) => {
                                            if (!(/^\d+$/.test(item.msisdn))) {
                                                item.Error = 1;
                                                item.Message = "devices_import_valid_msisdn_only_numbers";
                                                errorFound = true;
                                            } else {
                                                item.Error = 0;
                                                item.Message = "";
                                            }
                                        })
                                        setSelectedItems([...dvcs])
                                        if (errorFound) {
                                            error = 1;
                                            errorMessage = "devices_import_valid_msisdn_only_numbers_general";
                                        }
                                    }

                                    if (dvcs.filter(x => (x.Error)).length > 0) {
                                        error = 1;
                                        errorMessage = "devices_import_error_devices_selected";
                                    } else {
                                        setError(0);
                                        setErrorMessage(null);

                                        loadDevicesFeatures();
                                        setStep(4);
                                    }
                                    if (error === 1) {
                                        NotificationManager.error(messages[errorMessage], messages['devices_import_title'], 6000, null, null, '', null);
                                    }
                                } else {
                                    setStep(4);
                                }
                                break;
                            case 4:
                                if (isCSV) {
                                    setStep(5);
                                } else {
                                    dispatch(devicesImportSave(manufacturer, account, simProviderAccount, reference, selectedItems, timezone, []));
                                }
                                break;
                            case 5:
                                if (isCSV) {
                                    //call to import
                                    dispatch(devicesImportSave(manufacturer, account, simProviderAccount, reference, selectedItems, timezone, []));
                                }
                                break;
                            default:
                                break;
                        }

                    }}
                >
                    {step < 5 ? (step == 4 && !isCSV) ? messages['devices_import_save'] : messages['common_next'] : messages['devices_import_save']}
                </Button>
            </ModalFooter>
        </Modal >
    );
}

export default ImportDevices;